"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5527],{

/***/ 96699:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "J": function() { return /* binding */ DEFAULT_ENVIRONMENT; }
/* harmony export */ });
var DEFAULT_ENVIRONMENT = "production";
 //# sourceMappingURL=constants.js.map


/***/ }),

/***/ 80107:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "X": function() { return /* binding */ DEBUG_BUILD; }
/* harmony export */ });
/**
 * This serves as a build time flag that will be true by default, but false in non-debug builds or if users replace `__SENTRY_DEBUG__` in their generated code.
 *
 * ATTENTION: This constant must never cross package boundaries (i.e. be exported) to guarantee that it can be used for tree shaking.
 */ var DEBUG_BUILD =  false || false;
 //# sourceMappingURL=debug-build.js.map


/***/ }),

/***/ 38126:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "RP": function() { return /* binding */ notifyEventProcessors; },
/* harmony export */   "cc": function() { return /* binding */ addGlobalEventProcessor; },
/* harmony export */   "fH": function() { return /* binding */ getGlobalEventProcessors; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(26042);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(74672);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(21200);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(92957);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(74020);
/* harmony import */ var _debug_build_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(80107);



/**
 * Returns the global event processors.
 * @deprecated Global event processors will be removed in v8.
 */ function getGlobalEventProcessors() {
    return (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_0__/* .getGlobalSingleton */ .YO)("globalEventProcessors", function() {
        return [];
    });
}
/**
 * Add a EventProcessor to be kept globally.
 * @deprecated Use `addEventProcessor` instead. Global event processors will be removed in v8.
 */ function addGlobalEventProcessor(callback) {
    // eslint-disable-next-line deprecation/deprecation
    getGlobalEventProcessors().push(callback);
}
/**
 * Process an array of event processors, returning the processed event (or `null` if the event was dropped).
 */ function notifyEventProcessors(processors, event, hint) {
    var index = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 0;
    return new _sentry_utils__WEBPACK_IMPORTED_MODULE_1__/* .SyncPromise */ .cW(function(resolve, reject) {
        var processor = processors[index];
        if (event === null || typeof processor !== "function") {
            resolve(event);
        } else {
            var result = processor((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, event), hint);
            _debug_build_js__WEBPACK_IMPORTED_MODULE_3__/* .DEBUG_BUILD */ .X && processor.id && result === null && _sentry_utils__WEBPACK_IMPORTED_MODULE_4__/* .logger.log */ .kg.log('Event processor "'.concat(processor.id, '" dropped event'));
            if ((0,_sentry_utils__WEBPACK_IMPORTED_MODULE_5__/* .isThenable */ .J8)(result)) {
                void result.then(function(final) {
                    return notifyEventProcessors(processors, final, hint, index + 1).then(resolve);
                }).then(null, reject);
            } else {
                void notifyEventProcessors(processors, result, hint, index + 1).then(resolve).then(null, reject);
            }
        }
    });
}
 //# sourceMappingURL=eventProcessors.js.map


/***/ }),

/***/ 77668:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$e": function() { return /* binding */ withScope; },
/* harmony export */   "TM": function() { return /* binding */ endSession; },
/* harmony export */   "Tb": function() { return /* binding */ captureException; },
/* harmony export */   "YA": function() { return /* binding */ setTag; },
/* harmony export */   "Yr": function() { return /* binding */ startTransaction; },
/* harmony export */   "_d": function() { return /* binding */ withActiveSpan; },
/* harmony export */   "av": function() { return /* binding */ setUser; },
/* harmony export */   "c": function() { return /* binding */ captureCheckIn; },
/* harmony export */   "cg": function() { return /* binding */ captureSession; },
/* harmony export */   "dk": function() { return /* binding */ isInitialized; },
/* harmony export */   "e": function() { return /* binding */ configureScope; },
/* harmony export */   "eN": function() { return /* binding */ captureEvent; },
/* harmony export */   "eW": function() { return /* binding */ lastEventId; },
/* harmony export */   "mG": function() { return /* binding */ setTags; },
/* harmony export */   "nZ": function() { return /* binding */ getCurrentScope; },
/* harmony export */   "n_": function() { return /* binding */ addBreadcrumb; },
/* harmony export */   "rJ": function() { return /* binding */ setExtras; },
/* harmony export */   "s3": function() { return /* binding */ getClient; },
/* harmony export */   "sU": function() { return /* binding */ setExtra; },
/* harmony export */   "uT": function() { return /* binding */ captureMessage; },
/* harmony export */   "v": function() { return /* binding */ setContext; },
/* harmony export */   "wi": function() { return /* binding */ withIsolationScope; },
/* harmony export */   "xv": function() { return /* binding */ close; },
/* harmony export */   "yj": function() { return /* binding */ startSession; },
/* harmony export */   "yl": function() { return /* binding */ flush; }
/* harmony export */ });
/* unused harmony export withMonitor */
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(10253);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(97582);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(92957);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(11591);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(74672);
/* harmony import */ var _constants_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(96699);
/* harmony import */ var _debug_build_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(80107);
/* harmony import */ var _hub_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(19217);
/* harmony import */ var _session_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(36463);
/* harmony import */ var _utils_prepareEvent_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(70271);










/**
 * Captures an exception event and sends it to Sentry.
 *
 * @param exception The exception to capture.
 * @param hint Optional additional data to attach to the Sentry event.
 * @returns the id of the captured Sentry event.
 */ function captureException(// eslint-disable-next-line @typescript-eslint/no-explicit-any
exception, hint) {
    // eslint-disable-next-line deprecation/deprecation
    return (0,_hub_js__WEBPACK_IMPORTED_MODULE_0__/* .getCurrentHub */ .Gd)().captureException(exception, (0,_utils_prepareEvent_js__WEBPACK_IMPORTED_MODULE_1__/* .parseEventHintOrCaptureContext */ .U0)(hint));
}
/**
 * Captures a message event and sends it to Sentry.
 *
 * @param exception The exception to capture.
 * @param captureContext Define the level of the message or pass in additional data to attach to the message.
 * @returns the id of the captured message.
 */ function captureMessage(message, // eslint-disable-next-line deprecation/deprecation
captureContext) {
    // This is necessary to provide explicit scopes upgrade, without changing the original
    // arity of the `captureMessage(message, level)` method.
    var level = typeof captureContext === "string" ? captureContext : undefined;
    var context = typeof captureContext !== "string" ? {
        captureContext: captureContext
    } : undefined;
    // eslint-disable-next-line deprecation/deprecation
    return (0,_hub_js__WEBPACK_IMPORTED_MODULE_0__/* .getCurrentHub */ .Gd)().captureMessage(message, level, context);
}
/**
 * Captures a manually created event and sends it to Sentry.
 *
 * @param exception The event to send to Sentry.
 * @param hint Optional additional data to attach to the Sentry event.
 * @returns the id of the captured event.
 */ function captureEvent(event, hint) {
    // eslint-disable-next-line deprecation/deprecation
    return (0,_hub_js__WEBPACK_IMPORTED_MODULE_0__/* .getCurrentHub */ .Gd)().captureEvent(event, hint);
}
/**
 * Callback to set context information onto the scope.
 * @param callback Callback function that receives Scope.
 *
 * @deprecated Use getCurrentScope() directly.
 */ // eslint-disable-next-line deprecation/deprecation
function configureScope(callback) {
    // eslint-disable-next-line deprecation/deprecation
    (0,_hub_js__WEBPACK_IMPORTED_MODULE_0__/* .getCurrentHub */ .Gd)().configureScope(callback);
}
/**
 * Records a new breadcrumb which will be attached to future events.
 *
 * Breadcrumbs will be added to subsequent events to provide more context on
 * user's actions prior to an error or crash.
 *
 * @param breadcrumb The breadcrumb to record.
 */ // eslint-disable-next-line deprecation/deprecation
function addBreadcrumb(breadcrumb, hint) {
    // eslint-disable-next-line deprecation/deprecation
    (0,_hub_js__WEBPACK_IMPORTED_MODULE_0__/* .getCurrentHub */ .Gd)().addBreadcrumb(breadcrumb, hint);
}
/**
 * Sets context data with the given name.
 * @param name of the context
 * @param context Any kind of data. This data will be normalized.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any, deprecation/deprecation
function setContext(name, context) {
    // eslint-disable-next-line deprecation/deprecation
    (0,_hub_js__WEBPACK_IMPORTED_MODULE_0__/* .getCurrentHub */ .Gd)().setContext(name, context);
}
/**
 * Set an object that will be merged sent as extra data with the event.
 * @param extras Extras object to merge into current context.
 */ // eslint-disable-next-line deprecation/deprecation
function setExtras(extras) {
    // eslint-disable-next-line deprecation/deprecation
    (0,_hub_js__WEBPACK_IMPORTED_MODULE_0__/* .getCurrentHub */ .Gd)().setExtras(extras);
}
/**
 * Set key:value that will be sent as extra data with the event.
 * @param key String of extra
 * @param extra Any kind of data. This data will be normalized.
 */ // eslint-disable-next-line deprecation/deprecation
function setExtra(key, extra) {
    // eslint-disable-next-line deprecation/deprecation
    (0,_hub_js__WEBPACK_IMPORTED_MODULE_0__/* .getCurrentHub */ .Gd)().setExtra(key, extra);
}
/**
 * Set an object that will be merged sent as tags data with the event.
 * @param tags Tags context object to merge into current context.
 */ // eslint-disable-next-line deprecation/deprecation
function setTags(tags) {
    // eslint-disable-next-line deprecation/deprecation
    (0,_hub_js__WEBPACK_IMPORTED_MODULE_0__/* .getCurrentHub */ .Gd)().setTags(tags);
}
/**
 * Set key:value that will be sent as tags data with the event.
 *
 * Can also be used to unset a tag, by passing `undefined`.
 *
 * @param key String key of tag
 * @param value Value of tag
 */ // eslint-disable-next-line deprecation/deprecation
function setTag(key, value) {
    // eslint-disable-next-line deprecation/deprecation
    (0,_hub_js__WEBPACK_IMPORTED_MODULE_0__/* .getCurrentHub */ .Gd)().setTag(key, value);
}
/**
 * Updates user context information for future events.
 *
 * @param user User context object to be set in the current context. Pass `null` to unset the user.
 */ // eslint-disable-next-line deprecation/deprecation
function setUser(user) {
    // eslint-disable-next-line deprecation/deprecation
    (0,_hub_js__WEBPACK_IMPORTED_MODULE_0__/* .getCurrentHub */ .Gd)().setUser(user);
}
/**
 * Creates a new scope with and executes the given operation within.
 * The scope is automatically removed once the operation
 * finishes or throws.
 *
 * This is essentially a convenience function for:
 *
 *     pushScope();
 *     callback();
 *     popScope();
 */ /**
 * Either creates a new active scope, or sets the given scope as active scope in the given callback.
 */ function withScope() {
    for(var _len = arguments.length, rest = new Array(_len), _key = 0; _key < _len; _key++){
        rest[_key] = arguments[_key];
    }
    // eslint-disable-next-line deprecation/deprecation
    var hub = (0,_hub_js__WEBPACK_IMPORTED_MODULE_0__/* .getCurrentHub */ .Gd)();
    // If a scope is defined, we want to make this the active scope instead of the default one
    if (rest.length === 2) {
        var _rest = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(rest, 2), scope = _rest[0], callback = _rest[1];
        if (!scope) {
            // eslint-disable-next-line deprecation/deprecation
            return hub.withScope(callback);
        }
        // eslint-disable-next-line deprecation/deprecation
        return hub.withScope(function() {
            // eslint-disable-next-line deprecation/deprecation
            hub.getStackTop().scope = scope;
            return callback(scope);
        });
    }
    // eslint-disable-next-line deprecation/deprecation
    return hub.withScope(rest[0]);
}
/**
 * Attempts to fork the current isolation scope and the current scope based on the current async context strategy. If no
 * async context strategy is set, the isolation scope and the current scope will not be forked (this is currently the
 * case, for example, in the browser).
 *
 * Usage of this function in environments without async context strategy is discouraged and may lead to unexpected behaviour.
 *
 * This function is intended for Sentry SDK and SDK integration development. It is not recommended to be used in "normal"
 * applications directly because it comes with pitfalls. Use at your own risk!
 *
 * @param callback The callback in which the passed isolation scope is active. (Note: In environments without async
 * context strategy, the currently active isolation scope may change within execution of the callback.)
 * @returns The same value that `callback` returns.
 */ function withIsolationScope(callback) {
    return (0,_hub_js__WEBPACK_IMPORTED_MODULE_0__/* .runWithAsyncContext */ .Ok)(function() {
        return callback((0,_hub_js__WEBPACK_IMPORTED_MODULE_0__/* .getIsolationScope */ .aF)());
    });
}
/**
 * Forks the current scope and sets the provided span as active span in the context of the provided callback.
 *
 * @param span Spans started in the context of the provided callback will be children of this span.
 * @param callback Execution context in which the provided span will be active. Is passed the newly forked scope.
 * @returns the value returned from the provided callback function.
 */ function withActiveSpan(span, callback) {
    return withScope(function(scope) {
        // eslint-disable-next-line deprecation/deprecation
        scope.setSpan(span);
        return callback(scope);
    });
}
/**
 * Starts a new `Transaction` and returns it. This is the entry point to manual tracing instrumentation.
 *
 * A tree structure can be built by adding child spans to the transaction, and child spans to other spans. To start a
 * new child span within the transaction or any span, call the respective `.startChild()` method.
 *
 * Every child span must be finished before the transaction is finished, otherwise the unfinished spans are discarded.
 *
 * The transaction must be finished with a call to its `.end()` method, at which point the transaction with all its
 * finished child spans will be sent to Sentry.
 *
 * NOTE: This function should only be used for *manual* instrumentation. Auto-instrumentation should call
 * `startTransaction` directly on the hub.
 *
 * @param context Properties of the new `Transaction`.
 * @param customSamplingContext Information given to the transaction sampling function (along with context-dependent
 * default values). See {@link Options.tracesSampler}.
 *
 * @returns The transaction which was just started
 *
 * @deprecated Use `startSpan()`, `startSpanManual()` or `startInactiveSpan()` instead.
 */ function startTransaction(context, customSamplingContext) {
    // eslint-disable-next-line deprecation/deprecation
    return (0,_hub_js__WEBPACK_IMPORTED_MODULE_0__/* .getCurrentHub */ .Gd)().startTransaction((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, context), customSamplingContext);
}
/**
 * Create a cron monitor check in and send it to Sentry.
 *
 * @param checkIn An object that describes a check in.
 * @param upsertMonitorConfig An optional object that describes a monitor config. Use this if you want
 * to create a monitor automatically when sending a check in.
 */ function captureCheckIn(checkIn, upsertMonitorConfig) {
    var scope = getCurrentScope();
    var client = getClient();
    if (!client) {
        _debug_build_js__WEBPACK_IMPORTED_MODULE_4__/* .DEBUG_BUILD */ .X && _sentry_utils__WEBPACK_IMPORTED_MODULE_5__/* .logger.warn */ .kg.warn("Cannot capture check-in. No client defined.");
    } else if (!client.captureCheckIn) {
        _debug_build_js__WEBPACK_IMPORTED_MODULE_4__/* .DEBUG_BUILD */ .X && _sentry_utils__WEBPACK_IMPORTED_MODULE_5__/* .logger.warn */ .kg.warn("Cannot capture check-in. Client does not support sending check-ins.");
    } else {
        return client.captureCheckIn(checkIn, upsertMonitorConfig, scope);
    }
    return (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_6__/* .uuid4 */ .DM)();
}
/**
 * Wraps a callback with a cron monitor check in. The check in will be sent to Sentry when the callback finishes.
 *
 * @param monitorSlug The distinct slug of the monitor.
 * @param upsertMonitorConfig An optional object that describes a monitor config. Use this if you want
 * to create a monitor automatically when sending a check in.
 */ function withMonitor(monitorSlug, callback, upsertMonitorConfig) {
    var finishCheckIn = function finishCheckIn(status) {
        captureCheckIn({
            monitorSlug: monitorSlug,
            status: status,
            checkInId: checkInId,
            duration: timestampInSeconds() - now
        });
    };
    var checkInId = captureCheckIn({
        monitorSlug: monitorSlug,
        status: "in_progress"
    }, upsertMonitorConfig);
    var now = timestampInSeconds();
    var maybePromiseResult;
    try {
        maybePromiseResult = callback();
    } catch (e) {
        finishCheckIn("error");
        throw e;
    }
    if (isThenable(maybePromiseResult)) {
        Promise.resolve(maybePromiseResult).then(function() {
            finishCheckIn("ok");
        }, function() {
            finishCheckIn("error");
        });
    } else {
        finishCheckIn("ok");
    }
    return maybePromiseResult;
}
function flush(timeout) {
    return _flush.apply(this, arguments);
}
function _flush() {
    _flush = /**
 * Call `flush()` on the current client, if there is one. See {@link Client.flush}.
 *
 * @param timeout Maximum time in ms the client should wait to flush its event queue. Omitting this parameter will cause
 * the client to wait until all events are sent before resolving the promise.
 * @returns A promise which resolves to `true` if the queue successfully drains before the timeout, or `false` if it
 * doesn't (or if there's no client defined).
 */ (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(function(timeout) {
        var client;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_8__.__generator)(this, function(_state) {
            client = getClient();
            if (client) {
                return [
                    2,
                    client.flush(timeout)
                ];
            }
            _debug_build_js__WEBPACK_IMPORTED_MODULE_4__/* .DEBUG_BUILD */ .X && _sentry_utils__WEBPACK_IMPORTED_MODULE_5__/* .logger.warn */ .kg.warn("Cannot flush events. No client defined.");
            return [
                2,
                Promise.resolve(false)
            ];
        });
    });
    return _flush.apply(this, arguments);
}
function close(timeout) {
    return _close.apply(this, arguments);
}
function _close() {
    _close = /**
 * Call `close()` on the current client, if there is one. See {@link Client.close}.
 *
 * @param timeout Maximum time in ms the client should wait to flush its event queue before shutting down. Omitting this
 * parameter will cause the client to wait until all events are sent before disabling itself.
 * @returns A promise which resolves to `true` if the queue successfully drains before the timeout, or `false` if it
 * doesn't (or if there's no client defined).
 */ (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(function(timeout) {
        var client;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_8__.__generator)(this, function(_state) {
            client = getClient();
            if (client) {
                return [
                    2,
                    client.close(timeout)
                ];
            }
            _debug_build_js__WEBPACK_IMPORTED_MODULE_4__/* .DEBUG_BUILD */ .X && _sentry_utils__WEBPACK_IMPORTED_MODULE_5__/* .logger.warn */ .kg.warn("Cannot flush events and disable SDK. No client defined.");
            return [
                2,
                Promise.resolve(false)
            ];
        });
    });
    return _close.apply(this, arguments);
}
/**
 * This is the getter for lastEventId.
 *
 * @returns The last event id of a captured event.
 */ function lastEventId() {
    // eslint-disable-next-line deprecation/deprecation
    return (0,_hub_js__WEBPACK_IMPORTED_MODULE_0__/* .getCurrentHub */ .Gd)().lastEventId();
}
/**
 * Get the currently active client.
 */ function getClient() {
    // eslint-disable-next-line deprecation/deprecation
    return (0,_hub_js__WEBPACK_IMPORTED_MODULE_0__/* .getCurrentHub */ .Gd)().getClient();
}
/**
 * Returns true if Sentry has been properly initialized.
 */ function isInitialized() {
    return !!getClient();
}
/**
 * Get the currently active scope.
 */ function getCurrentScope() {
    // eslint-disable-next-line deprecation/deprecation
    return (0,_hub_js__WEBPACK_IMPORTED_MODULE_0__/* .getCurrentHub */ .Gd)().getScope();
}
/**
 * Start a session on the current isolation scope.
 *
 * @param context (optional) additional properties to be applied to the returned session object
 *
 * @returns the new active session
 */ function startSession(context) {
    var client = getClient();
    var isolationScope = (0,_hub_js__WEBPACK_IMPORTED_MODULE_0__/* .getIsolationScope */ .aF)();
    var currentScope = getCurrentScope();
    var ref = client && client.getOptions() || {}, release = ref.release, _environment = ref.environment, environment = _environment === void 0 ? _constants_js__WEBPACK_IMPORTED_MODULE_9__/* .DEFAULT_ENVIRONMENT */ .J : _environment;
    // Will fetch userAgent if called from browser sdk
    var userAgent = (_sentry_utils__WEBPACK_IMPORTED_MODULE_10__/* .GLOBAL_OBJ.navigator */ .n2.navigator || {}).userAgent;
    var session = (0,_session_js__WEBPACK_IMPORTED_MODULE_11__/* .makeSession */ .Hv)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
        release: release,
        environment: environment,
        user: currentScope.getUser() || isolationScope.getUser()
    }, userAgent && {
        userAgent: userAgent
    }, context));
    // End existing session if there's one
    var currentSession = isolationScope.getSession();
    if (currentSession && currentSession.status === "ok") {
        (0,_session_js__WEBPACK_IMPORTED_MODULE_11__/* .updateSession */ .CT)(currentSession, {
            status: "exited"
        });
    }
    endSession();
    // Afterwards we set the new session on the scope
    isolationScope.setSession(session);
    // TODO (v8): Remove this and only use the isolation scope(?).
    // For v7 though, we can't "soft-break" people using getCurrentHub().getScope().setSession()
    currentScope.setSession(session);
    return session;
}
/**
 * End the session on the current isolation scope.
 */ function endSession() {
    var isolationScope = (0,_hub_js__WEBPACK_IMPORTED_MODULE_0__/* .getIsolationScope */ .aF)();
    var currentScope = getCurrentScope();
    var session = currentScope.getSession() || isolationScope.getSession();
    if (session) {
        (0,_session_js__WEBPACK_IMPORTED_MODULE_11__/* .closeSession */ .RJ)(session);
    }
    _sendSessionUpdate();
    // the session is over; take it off of the scope
    isolationScope.setSession();
    // TODO (v8): Remove this and only use the isolation scope(?).
    // For v7 though, we can't "soft-break" people using getCurrentHub().getScope().setSession()
    currentScope.setSession();
}
/**
 * Sends the current Session on the scope
 */ function _sendSessionUpdate() {
    var isolationScope = (0,_hub_js__WEBPACK_IMPORTED_MODULE_0__/* .getIsolationScope */ .aF)();
    var currentScope = getCurrentScope();
    var client = getClient();
    // TODO (v8): Remove currentScope and only use the isolation scope(?).
    // For v7 though, we can't "soft-break" people using getCurrentHub().getScope().setSession()
    var session = currentScope.getSession() || isolationScope.getSession();
    if (session && client && client.captureSession) {
        client.captureSession(session);
    }
}
/**
 * Sends the current session on the scope to Sentry
 *
 * @param end If set the session will be marked as exited and removed from the scope.
 *            Defaults to `false`.
 */ function captureSession() {
    var end = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
    // both send the update and pull the session from the scope
    if (end) {
        endSession();
        return;
    }
    // only send the update
    _sendSessionUpdate();
}
 //# sourceMappingURL=exports.js.map


/***/ }),

/***/ 19217:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Gd": function() { return /* binding */ getCurrentHub; },
/* harmony export */   "Ok": function() { return /* binding */ runWithAsyncContext; },
/* harmony export */   "Xb": function() { return /* binding */ Hub; },
/* harmony export */   "aF": function() { return /* binding */ getIsolationScope; },
/* harmony export */   "cu": function() { return /* binding */ getMainCarrier; },
/* harmony export */   "pj": function() { return /* binding */ makeMain; },
/* harmony export */   "vi": function() { return /* binding */ getHubFromCarrier; }
/* harmony export */ });
/* unused harmony exports API_VERSION, ensureHubOnCarrier, setAsyncContextStrategy, setHubOnCarrier */
/* harmony import */ var _swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(51438);
/* harmony import */ var _swc_helpers_src_create_class_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(52951);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(69396);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(74020);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(11591);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(96233);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(92957);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(74672);
/* harmony import */ var _constants_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(96699);
/* harmony import */ var _debug_build_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(80107);
/* harmony import */ var _scope_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(29791);
/* harmony import */ var _session_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(36463);
/* harmony import */ var _version_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(63935);










/**
 * API compatibility version of this hub.
 *
 * WARNING: This number should only be increased when the global interface
 * changes and new methods are introduced.
 *
 * @hidden
 */ var API_VERSION = parseFloat(_version_js__WEBPACK_IMPORTED_MODULE_0__/* .SDK_VERSION */ .J);
/**
 * Default maximum number of breadcrumbs added to an event. Can be overwritten
 * with {@link Options.maxBreadcrumbs}.
 */ var DEFAULT_BREADCRUMBS = 100;
/**
 * @deprecated The `Hub` class will be removed in version 8 of the SDK in favour of `Scope` and `Client` objects.
 *
 * If you previously used the `Hub` class directly, replace it with `Scope` and `Client` objects. More information:
 * - [Multiple Sentry Instances](https://docs.sentry.io/platforms/javascript/best-practices/multiple-sentry-instances/)
 * - [Browser Extensions](https://docs.sentry.io/platforms/javascript/best-practices/browser-extensions/)
 *
 * Some of our APIs are typed with the Hub class instead of the interface (e.g. `getCurrentHub`). Most of them are deprecated
 * themselves and will also be removed in version 8. More information:
 * - [Migration Guide](https://github.com/getsentry/sentry-javascript/blob/develop/MIGRATION.md#deprecate-hub)
 */ // eslint-disable-next-line deprecation/deprecation
var Hub = /*#__PURE__*/ function() {
    "use strict";
    function Hub(client, scope, isolationScope) {
        var _version = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : API_VERSION;
        (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(this, Hub);
        this._version = _version;
        var assignedScope;
        if (!scope) {
            assignedScope = new _scope_js__WEBPACK_IMPORTED_MODULE_2__/* .Scope */ .sX();
            assignedScope.setClient(client);
        } else {
            assignedScope = scope;
        }
        var assignedIsolationScope;
        if (!isolationScope) {
            assignedIsolationScope = new _scope_js__WEBPACK_IMPORTED_MODULE_2__/* .Scope */ .sX();
            assignedIsolationScope.setClient(client);
        } else {
            assignedIsolationScope = isolationScope;
        }
        this._stack = [
            {
                scope: assignedScope
            }
        ];
        if (client) {
            // eslint-disable-next-line deprecation/deprecation
            this.bindClient(client);
        }
        this._isolationScope = assignedIsolationScope;
    }
    (0,_swc_helpers_src_create_class_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(Hub, [
        {
            /**
   * Checks if this hub's version is older than the given version.
   *
   * @param version A version number to compare to.
   * @return True if the given version is newer; otherwise false.
   *
   * @deprecated This will be removed in v8.
   */ key: "isOlderThan",
            value: function isOlderThan(version) {
                return this._version < version;
            }
        },
        {
            /**
   * This binds the given client to the current scope.
   * @param client An SDK client (client) instance.
   *
   * @deprecated Use `initAndBind()` directly, or `setCurrentClient()` and/or `client.init()` instead.
   */ key: "bindClient",
            value: function bindClient(client) {
                // eslint-disable-next-line deprecation/deprecation
                var top = this.getStackTop();
                top.client = client;
                top.scope.setClient(client);
                // eslint-disable-next-line deprecation/deprecation
                if (client && client.setupIntegrations) {
                    // eslint-disable-next-line deprecation/deprecation
                    client.setupIntegrations();
                }
            }
        },
        {
            /**
   * @inheritDoc
   *
   * @deprecated Use `withScope` instead.
   */ key: "pushScope",
            value: function pushScope() {
                // We want to clone the content of prev scope
                // eslint-disable-next-line deprecation/deprecation
                var scope = this.getScope().clone();
                // eslint-disable-next-line deprecation/deprecation
                this.getStack().push({
                    // eslint-disable-next-line deprecation/deprecation
                    client: this.getClient(),
                    scope: scope
                });
                return scope;
            }
        },
        {
            /**
   * @inheritDoc
   *
   * @deprecated Use `withScope` instead.
   */ key: "popScope",
            value: function popScope() {
                // eslint-disable-next-line deprecation/deprecation
                if (this.getStack().length <= 1) return false;
                // eslint-disable-next-line deprecation/deprecation
                return !!this.getStack().pop();
            }
        },
        {
            /**
   * @inheritDoc
   *
   * @deprecated Use `Sentry.withScope()` instead.
   */ key: "withScope",
            value: function withScope(callback) {
                var _this = this;
                // eslint-disable-next-line deprecation/deprecation
                var scope = this.pushScope();
                var maybePromiseResult;
                try {
                    maybePromiseResult = callback(scope);
                } catch (e) {
                    // eslint-disable-next-line deprecation/deprecation
                    this.popScope();
                    throw e;
                }
                if ((0,_sentry_utils__WEBPACK_IMPORTED_MODULE_4__/* .isThenable */ .J8)(maybePromiseResult)) {
                    // @ts-expect-error - isThenable returns the wrong type
                    return maybePromiseResult.then(function(res) {
                        // eslint-disable-next-line deprecation/deprecation
                        _this.popScope();
                        return res;
                    }, function(e) {
                        // eslint-disable-next-line deprecation/deprecation
                        _this.popScope();
                        throw e;
                    });
                }
                // eslint-disable-next-line deprecation/deprecation
                this.popScope();
                return maybePromiseResult;
            }
        },
        {
            /**
   * @inheritDoc
   *
   * @deprecated Use `Sentry.getClient()` instead.
   */ key: "getClient",
            value: function getClient() {
                // eslint-disable-next-line deprecation/deprecation
                return this.getStackTop().client;
            }
        },
        {
            /**
   * Returns the scope of the top stack.
   *
   * @deprecated Use `Sentry.getCurrentScope()` instead.
   */ key: "getScope",
            value: function getScope() {
                // eslint-disable-next-line deprecation/deprecation
                return this.getStackTop().scope;
            }
        },
        {
            /**
   * @deprecated Use `Sentry.getIsolationScope()` instead.
   */ key: "getIsolationScope",
            value: function getIsolationScope() {
                return this._isolationScope;
            }
        },
        {
            /**
   * Returns the scope stack for domains or the process.
   * @deprecated This will be removed in v8.
   */ key: "getStack",
            value: function getStack() {
                return this._stack;
            }
        },
        {
            /**
   * Returns the topmost scope layer in the order domain > local > process.
   * @deprecated This will be removed in v8.
   */ key: "getStackTop",
            value: function getStackTop() {
                return this._stack[this._stack.length - 1];
            }
        },
        {
            /**
   * @inheritDoc
   *
   * @deprecated Use `Sentry.captureException()` instead.
   */ key: "captureException",
            value: function captureException(exception, hint) {
                var eventId = this._lastEventId = hint && hint.event_id ? hint.event_id : (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_5__/* .uuid4 */ .DM)();
                var syntheticException = new Error("Sentry syntheticException");
                // eslint-disable-next-line deprecation/deprecation
                this.getScope().captureException(exception, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({
                    originalException: exception,
                    syntheticException: syntheticException
                }, hint), {
                    event_id: eventId
                }));
                return eventId;
            }
        },
        {
            /**
   * @inheritDoc
   *
   * @deprecated Use  `Sentry.captureMessage()` instead.
   */ key: "captureMessage",
            value: function captureMessage(message, // eslint-disable-next-line deprecation/deprecation
            level, hint) {
                var eventId = this._lastEventId = hint && hint.event_id ? hint.event_id : (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_5__/* .uuid4 */ .DM)();
                var syntheticException = new Error(message);
                // eslint-disable-next-line deprecation/deprecation
                this.getScope().captureMessage(message, level, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({
                    originalException: message,
                    syntheticException: syntheticException
                }, hint), {
                    event_id: eventId
                }));
                return eventId;
            }
        },
        {
            /**
   * @inheritDoc
   *
   * @deprecated Use `Sentry.captureEvent()` instead.
   */ key: "captureEvent",
            value: function captureEvent(event, hint) {
                var eventId = hint && hint.event_id ? hint.event_id : (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_5__/* .uuid4 */ .DM)();
                if (!event.type) {
                    this._lastEventId = eventId;
                }
                // eslint-disable-next-line deprecation/deprecation
                this.getScope().captureEvent(event, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({}, hint), {
                    event_id: eventId
                }));
                return eventId;
            }
        },
        {
            /**
   * @inheritDoc
   *
   * @deprecated This will be removed in v8.
   */ key: "lastEventId",
            value: function lastEventId() {
                return this._lastEventId;
            }
        },
        {
            /**
   * @inheritDoc
   *
   * @deprecated Use `Sentry.addBreadcrumb()` instead.
   */ key: "addBreadcrumb",
            value: function addBreadcrumb(breadcrumb, hint) {
                // eslint-disable-next-line deprecation/deprecation
                var ref = this.getStackTop(), scope = ref.scope, client = ref.client;
                if (!client) return;
                var ref1 = client.getOptions && client.getOptions() || {}, _beforeBreadcrumb = ref1.beforeBreadcrumb, beforeBreadcrumb = _beforeBreadcrumb === void 0 ? null : _beforeBreadcrumb, _maxBreadcrumbs = ref1.maxBreadcrumbs, maxBreadcrumbs = _maxBreadcrumbs === void 0 ? DEFAULT_BREADCRUMBS : _maxBreadcrumbs;
                if (maxBreadcrumbs <= 0) return;
                var timestamp = (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_8__/* .dateTimestampInSeconds */ .yW)();
                var mergedBreadcrumb = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({
                    timestamp: timestamp
                }, breadcrumb);
                var finalBreadcrumb = beforeBreadcrumb ? (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_9__/* .consoleSandbox */ .Cf)(function() {
                    return beforeBreadcrumb(mergedBreadcrumb, hint);
                }) : mergedBreadcrumb;
                if (finalBreadcrumb === null) return;
                if (client.emit) {
                    client.emit("beforeAddBreadcrumb", finalBreadcrumb, hint);
                }
                // TODO(v8): I know this comment doesn't make much sense because the hub will be deprecated but I still wanted to
                // write it down. In theory, we would have to add the breadcrumbs to the isolation scope here, however, that would
                // duplicate all of the breadcrumbs. There was the possibility of adding breadcrumbs to both, the isolation scope
                // and the normal scope, and deduplicating it down the line in the event processing pipeline. However, that would
                // have been very fragile, because the breadcrumb objects would have needed to keep their identity all throughout
                // the event processing pipeline.
                // In the new implementation, the top level `Sentry.addBreadcrumb()` should ONLY write to the isolation scope.
                scope.addBreadcrumb(finalBreadcrumb, maxBreadcrumbs);
            }
        },
        {
            /**
   * @inheritDoc
   * @deprecated Use `Sentry.setUser()` instead.
   */ key: "setUser",
            value: function setUser(user) {
                // TODO(v8): The top level `Sentry.setUser()` function should write ONLY to the isolation scope.
                // eslint-disable-next-line deprecation/deprecation
                this.getScope().setUser(user);
                // eslint-disable-next-line deprecation/deprecation
                this.getIsolationScope().setUser(user);
            }
        },
        {
            /**
   * @inheritDoc
   * @deprecated Use `Sentry.setTags()` instead.
   */ key: "setTags",
            value: function setTags(tags) {
                // TODO(v8): The top level `Sentry.setTags()` function should write ONLY to the isolation scope.
                // eslint-disable-next-line deprecation/deprecation
                this.getScope().setTags(tags);
                // eslint-disable-next-line deprecation/deprecation
                this.getIsolationScope().setTags(tags);
            }
        },
        {
            /**
   * @inheritDoc
   * @deprecated Use `Sentry.setExtras()` instead.
   */ key: "setExtras",
            value: function setExtras(extras) {
                // TODO(v8): The top level `Sentry.setExtras()` function should write ONLY to the isolation scope.
                // eslint-disable-next-line deprecation/deprecation
                this.getScope().setExtras(extras);
                // eslint-disable-next-line deprecation/deprecation
                this.getIsolationScope().setExtras(extras);
            }
        },
        {
            /**
   * @inheritDoc
   * @deprecated Use `Sentry.setTag()` instead.
   */ key: "setTag",
            value: function setTag(key, value) {
                // TODO(v8): The top level `Sentry.setTag()` function should write ONLY to the isolation scope.
                // eslint-disable-next-line deprecation/deprecation
                this.getScope().setTag(key, value);
                // eslint-disable-next-line deprecation/deprecation
                this.getIsolationScope().setTag(key, value);
            }
        },
        {
            /**
   * @inheritDoc
   * @deprecated Use `Sentry.setExtra()` instead.
   */ key: "setExtra",
            value: function setExtra(key, extra) {
                // TODO(v8): The top level `Sentry.setExtra()` function should write ONLY to the isolation scope.
                // eslint-disable-next-line deprecation/deprecation
                this.getScope().setExtra(key, extra);
                // eslint-disable-next-line deprecation/deprecation
                this.getIsolationScope().setExtra(key, extra);
            }
        },
        {
            /**
   * @inheritDoc
   * @deprecated Use `Sentry.setContext()` instead.
   */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
            key: "setContext",
            value: function setContext(name, context) {
                // TODO(v8): The top level `Sentry.setContext()` function should write ONLY to the isolation scope.
                // eslint-disable-next-line deprecation/deprecation
                this.getScope().setContext(name, context);
                // eslint-disable-next-line deprecation/deprecation
                this.getIsolationScope().setContext(name, context);
            }
        },
        {
            /**
   * @inheritDoc
   *
   * @deprecated Use `getScope()` directly.
   */ key: "configureScope",
            value: function configureScope(callback) {
                // eslint-disable-next-line deprecation/deprecation
                var ref = this.getStackTop(), scope = ref.scope, client = ref.client;
                if (client) {
                    callback(scope);
                }
            }
        },
        {
            /**
   * @inheritDoc
   */ // eslint-disable-next-line deprecation/deprecation
            key: "run",
            value: function run(callback) {
                // eslint-disable-next-line deprecation/deprecation
                var oldHub = makeMain(this);
                try {
                    callback(this);
                } finally{
                    // eslint-disable-next-line deprecation/deprecation
                    makeMain(oldHub);
                }
            }
        },
        {
            /**
   * @inheritDoc
   * @deprecated Use `Sentry.getClient().getIntegrationByName()` instead.
   */ key: "getIntegration",
            value: function getIntegration(integration) {
                // eslint-disable-next-line deprecation/deprecation
                var client = this.getClient();
                if (!client) return null;
                try {
                    // eslint-disable-next-line deprecation/deprecation
                    return client.getIntegration(integration);
                } catch (_oO) {
                    _debug_build_js__WEBPACK_IMPORTED_MODULE_10__/* .DEBUG_BUILD */ .X && _sentry_utils__WEBPACK_IMPORTED_MODULE_9__/* .logger.warn */ .kg.warn("Cannot retrieve integration ".concat(integration.id, " from the current Hub"));
                    return null;
                }
            }
        },
        {
            /**
   * Starts a new `Transaction` and returns it. This is the entry point to manual tracing instrumentation.
   *
   * A tree structure can be built by adding child spans to the transaction, and child spans to other spans. To start a
   * new child span within the transaction or any span, call the respective `.startChild()` method.
   *
   * Every child span must be finished before the transaction is finished, otherwise the unfinished spans are discarded.
   *
   * The transaction must be finished with a call to its `.end()` method, at which point the transaction with all its
   * finished child spans will be sent to Sentry.
   *
   * @param context Properties of the new `Transaction`.
   * @param customSamplingContext Information given to the transaction sampling function (along with context-dependent
   * default values). See {@link Options.tracesSampler}.
   *
   * @returns The transaction which was just started
   *
   * @deprecated Use `startSpan()`, `startSpanManual()` or `startInactiveSpan()` instead.
   */ key: "startTransaction",
            value: function startTransaction(context, customSamplingContext) {
                var result = this._callExtensionMethod("startTransaction", context, customSamplingContext);
                if (_debug_build_js__WEBPACK_IMPORTED_MODULE_10__/* .DEBUG_BUILD */ .X && !result) {
                    // eslint-disable-next-line deprecation/deprecation
                    var client = this.getClient();
                    if (!client) {
                        _sentry_utils__WEBPACK_IMPORTED_MODULE_9__/* .logger.warn */ .kg.warn("Tracing extension 'startTransaction' is missing. You should 'init' the SDK before calling 'startTransaction'");
                    } else {
                        _sentry_utils__WEBPACK_IMPORTED_MODULE_9__/* .logger.warn */ .kg.warn("Tracing extension 'startTransaction' has not been added. Call 'addTracingExtensions' before calling 'init':\nSentry.addTracingExtensions();\nSentry.init({...});\n");
                    }
                }
                return result;
            }
        },
        {
            /**
   * @inheritDoc
   * @deprecated Use `spanToTraceHeader()` instead.
   */ key: "traceHeaders",
            value: function traceHeaders() {
                return this._callExtensionMethod("traceHeaders");
            }
        },
        {
            /**
   * @inheritDoc
   *
   * @deprecated Use top level `captureSession` instead.
   */ key: "captureSession",
            value: function captureSession() {
                var endSession = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
                // both send the update and pull the session from the scope
                if (endSession) {
                    // eslint-disable-next-line deprecation/deprecation
                    return this.endSession();
                }
                // only send the update
                this._sendSessionUpdate();
            }
        },
        {
            /**
   * @inheritDoc
   * @deprecated Use top level `endSession` instead.
   */ key: "endSession",
            value: function endSession() {
                // eslint-disable-next-line deprecation/deprecation
                var layer = this.getStackTop();
                var scope = layer.scope;
                var session = scope.getSession();
                if (session) {
                    (0,_session_js__WEBPACK_IMPORTED_MODULE_11__/* .closeSession */ .RJ)(session);
                }
                this._sendSessionUpdate();
                // the session is over; take it off of the scope
                scope.setSession();
            }
        },
        {
            /**
   * @inheritDoc
   * @deprecated Use top level `startSession` instead.
   */ key: "startSession",
            value: function startSession(context) {
                // eslint-disable-next-line deprecation/deprecation
                var ref = this.getStackTop(), scope = ref.scope, client = ref.client;
                var ref1 = client && client.getOptions() || {}, release = ref1.release, _environment = ref1.environment, environment = _environment === void 0 ? _constants_js__WEBPACK_IMPORTED_MODULE_12__/* .DEFAULT_ENVIRONMENT */ .J : _environment;
                // Will fetch userAgent if called from browser sdk
                var userAgent = (_sentry_utils__WEBPACK_IMPORTED_MODULE_13__/* .GLOBAL_OBJ.navigator */ .n2.navigator || {}).userAgent;
                var session = (0,_session_js__WEBPACK_IMPORTED_MODULE_11__/* .makeSession */ .Hv)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({
                    release: release,
                    environment: environment,
                    user: scope.getUser()
                }, userAgent && {
                    userAgent: userAgent
                }, context));
                // End existing session if there's one
                var currentSession = scope.getSession && scope.getSession();
                if (currentSession && currentSession.status === "ok") {
                    (0,_session_js__WEBPACK_IMPORTED_MODULE_11__/* .updateSession */ .CT)(currentSession, {
                        status: "exited"
                    });
                }
                // eslint-disable-next-line deprecation/deprecation
                this.endSession();
                // Afterwards we set the new session on the scope
                scope.setSession(session);
                return session;
            }
        },
        {
            /**
   * Returns if default PII should be sent to Sentry and propagated in ourgoing requests
   * when Tracing is used.
   *
   * @deprecated Use top-level `getClient().getOptions().sendDefaultPii` instead. This function
   * only unnecessarily increased API surface but only wrapped accessing the option.
   */ key: "shouldSendDefaultPii",
            value: function shouldSendDefaultPii() {
                // eslint-disable-next-line deprecation/deprecation
                var client = this.getClient();
                var options = client && client.getOptions();
                return Boolean(options && options.sendDefaultPii);
            }
        },
        {
            /**
   * Sends the current Session on the scope
   */ key: "_sendSessionUpdate",
            value: function _sendSessionUpdate() {
                // eslint-disable-next-line deprecation/deprecation
                var ref = this.getStackTop(), scope = ref.scope, client = ref.client;
                var session = scope.getSession();
                if (session && client && client.captureSession) {
                    client.captureSession(session);
                }
            }
        },
        {
            /**
   * Calls global extension method and binding current instance to the function call
   */ // @ts-expect-error Function lacks ending return statement and return type does not include 'undefined'. ts(2366)
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            key: "_callExtensionMethod",
            value: function _callExtensionMethod(method) {
                for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
                    args[_key - 1] = arguments[_key];
                }
                var carrier = getMainCarrier();
                var sentry = carrier.__SENTRY__;
                if (sentry && sentry.extensions && typeof sentry.extensions[method] === "function") {
                    return sentry.extensions[method].apply(this, args);
                }
                _debug_build_js__WEBPACK_IMPORTED_MODULE_10__/* .DEBUG_BUILD */ .X && _sentry_utils__WEBPACK_IMPORTED_MODULE_9__/* .logger.warn */ .kg.warn("Extension method ".concat(method, " couldn't be found, doing nothing."));
            }
        }
    ]);
    return Hub;
}();
/**
 * Returns the global shim registry.
 *
 * FIXME: This function is problematic, because despite always returning a valid Carrier,
 * it has an optional `__SENTRY__` property, which then in turn requires us to always perform an unnecessary check
 * at the call-site. We always access the carrier through this function, so we can guarantee that `__SENTRY__` is there.
 **/ function getMainCarrier() {
    _sentry_utils__WEBPACK_IMPORTED_MODULE_13__/* .GLOBAL_OBJ.__SENTRY__ */ .n2.__SENTRY__ = _sentry_utils__WEBPACK_IMPORTED_MODULE_13__/* .GLOBAL_OBJ.__SENTRY__ */ .n2.__SENTRY__ || {
        extensions: {},
        hub: undefined
    };
    return _sentry_utils__WEBPACK_IMPORTED_MODULE_13__/* .GLOBAL_OBJ */ .n2;
}
/**
 * Replaces the current main hub with the passed one on the global object
 *
 * @returns The old replaced hub
 *
 * @deprecated Use `setCurrentClient()` instead.
 */ // eslint-disable-next-line deprecation/deprecation
function makeMain(hub) {
    var registry = getMainCarrier();
    var oldHub = getHubFromCarrier(registry);
    setHubOnCarrier(registry, hub);
    return oldHub;
}
/**
 * Returns the default hub instance.
 *
 * If a hub is already registered in the global carrier but this module
 * contains a more recent version, it replaces the registered version.
 * Otherwise, the currently registered hub will be returned.
 *
 * @deprecated Use the respective replacement method directly instead.
 */ // eslint-disable-next-line deprecation/deprecation
function getCurrentHub() {
    // Get main carrier (global for every environment)
    var registry = getMainCarrier();
    if (registry.__SENTRY__ && registry.__SENTRY__.acs) {
        var hub = registry.__SENTRY__.acs.getCurrentHub();
        if (hub) {
            return hub;
        }
    }
    // Return hub that lives on a global object
    return getGlobalHub(registry);
}
/**
 * Get the currently active isolation scope.
 * The isolation scope is active for the current exection context,
 * meaning that it will remain stable for the same Hub.
 */ function getIsolationScope() {
    // eslint-disable-next-line deprecation/deprecation
    return getCurrentHub().getIsolationScope();
}
// eslint-disable-next-line deprecation/deprecation
function getGlobalHub() {
    var registry = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : getMainCarrier();
    // If there's no hub, or its an old API, assign a new one
    if (!hasHubOnCarrier(registry) || // eslint-disable-next-line deprecation/deprecation
    getHubFromCarrier(registry).isOlderThan(API_VERSION)) {
        // eslint-disable-next-line deprecation/deprecation
        setHubOnCarrier(registry, new Hub());
    }
    // Return hub that lives on a global object
    return getHubFromCarrier(registry);
}
/**
 * @private Private API with no semver guarantees!
 *
 * If the carrier does not contain a hub, a new hub is created with the global hub client and scope.
 */ // eslint-disable-next-line deprecation/deprecation
function ensureHubOnCarrier(carrier) {
    var parent = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : getGlobalHub();
    // If there's no hub on current domain, or it's an old API, assign a new one
    if (!hasHubOnCarrier(carrier) || // eslint-disable-next-line deprecation/deprecation
    getHubFromCarrier(carrier).isOlderThan(API_VERSION)) {
        // eslint-disable-next-line deprecation/deprecation
        var client = parent.getClient();
        // eslint-disable-next-line deprecation/deprecation
        var scope = parent.getScope();
        // eslint-disable-next-line deprecation/deprecation
        var isolationScope = parent.getIsolationScope();
        // eslint-disable-next-line deprecation/deprecation
        setHubOnCarrier(carrier, new Hub(client, scope.clone(), isolationScope.clone()));
    }
}
/**
 * @private Private API with no semver guarantees!
 *
 * Sets the global async context strategy
 */ function setAsyncContextStrategy(strategy) {
    // Get main carrier (global for every environment)
    var registry = getMainCarrier();
    registry.__SENTRY__ = registry.__SENTRY__ || {};
    registry.__SENTRY__.acs = strategy;
}
/**
 * Runs the supplied callback in its own async context. Async Context strategies are defined per SDK.
 *
 * @param callback The callback to run in its own async context
 * @param options Options to pass to the async context strategy
 * @returns The result of the callback
 */ function runWithAsyncContext(callback) {
    var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    var registry = getMainCarrier();
    if (registry.__SENTRY__ && registry.__SENTRY__.acs) {
        return registry.__SENTRY__.acs.runWithAsyncContext(callback, options);
    }
    // if there was no strategy, fallback to just calling the callback
    return callback();
}
/**
 * This will tell whether a carrier has a hub on it or not
 * @param carrier object
 */ function hasHubOnCarrier(carrier) {
    return !!(carrier && carrier.__SENTRY__ && carrier.__SENTRY__.hub);
}
/**
 * This will create a new {@link Hub} and add to the passed object on
 * __SENTRY__.hub.
 * @param carrier object
 * @hidden
 */ // eslint-disable-next-line deprecation/deprecation
function getHubFromCarrier(carrier) {
    // eslint-disable-next-line deprecation/deprecation
    return (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_13__/* .getGlobalSingleton */ .YO)("hub", function() {
        return new Hub();
    }, carrier);
}
/**
 * This will set passed {@link Hub} on the passed object's __SENTRY__.hub attribute
 * @param carrier object
 * @param hub Hub
 * @returns A boolean indicating success or failure
 */ // eslint-disable-next-line deprecation/deprecation
function setHubOnCarrier(carrier, hub) {
    if (!carrier) return false;
    var __SENTRY__ = carrier.__SENTRY__ = carrier.__SENTRY__ || {};
    __SENTRY__.hub = hub;
    return true;
}
 //# sourceMappingURL=hub.js.map


/***/ }),

/***/ 29791:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "lW": function() { return /* binding */ getGlobalScope; },
/* harmony export */   "sX": function() { return /* binding */ Scope; }
/* harmony export */ });
/* unused harmony export setGlobalScope */
/* harmony import */ var _swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(51438);
/* harmony import */ var _swc_helpers_src_create_class_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52951);
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(14924);
/* harmony import */ var _swc_helpers_src_instanceof_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(82670);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(36305);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(74020);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(96233);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(11591);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(92957);
/* harmony import */ var _eventProcessors_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(38126);
/* harmony import */ var _session_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(36463);
/* harmony import */ var _utils_applyScopeDataToEvent_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(56559);











/**
 * Default value for maximum number of breadcrumbs added to an event.
 */ var DEFAULT_MAX_BREADCRUMBS = 100;
/**
 * The global scope is kept in this module.
 * When accessing this via `getGlobalScope()` we'll make sure to set one if none is currently present.
 */ var globalScope;
/**
 * Holds additional event information. {@link Scope.applyToEvent} will be
 * called by the client before an event will be sent.
 */ var Scope = /*#__PURE__*/ function() {
    "use strict";
    function Scope() {
        (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(this, Scope);
        this._notifyingListeners = false;
        this._scopeListeners = [];
        this._eventProcessors = [];
        this._breadcrumbs = [];
        this._attachments = [];
        this._user = {};
        this._tags = {};
        this._extra = {};
        this._contexts = {};
        this._sdkProcessingMetadata = {};
        this._propagationContext = generatePropagationContext();
    }
    (0,_swc_helpers_src_create_class_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(Scope, [
        {
            /**
   * Clone this scope instance.
   */ key: "clone",
            value: function clone() {
                var newScope = new Scope();
                newScope._breadcrumbs = (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(this._breadcrumbs);
                newScope._tags = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, this._tags);
                newScope._extra = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, this._extra);
                newScope._contexts = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, this._contexts);
                newScope._user = this._user;
                newScope._level = this._level;
                newScope._span = this._span;
                newScope._session = this._session;
                newScope._transactionName = this._transactionName;
                newScope._fingerprint = this._fingerprint;
                newScope._eventProcessors = (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(this._eventProcessors);
                newScope._requestSession = this._requestSession;
                newScope._attachments = (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(this._attachments);
                newScope._sdkProcessingMetadata = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, this._sdkProcessingMetadata);
                newScope._propagationContext = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, this._propagationContext);
                newScope._client = this._client;
                return newScope;
            }
        },
        {
            /** Update the client on the scope. */ key: "setClient",
            value: function setClient(client) {
                this._client = client;
            }
        },
        {
            /**
   * Get the client assigned to this scope.
   *
   * It is generally recommended to use the global function `Sentry.getClient()` instead, unless you know what you are doing.
   */ key: "getClient",
            value: function getClient() {
                return this._client;
            }
        },
        {
            /**
   * Add internal on change listener. Used for sub SDKs that need to store the scope.
   * @hidden
   */ key: "addScopeListener",
            value: function addScopeListener(callback) {
                this._scopeListeners.push(callback);
            }
        },
        {
            /**
   * @inheritDoc
   */ key: "addEventProcessor",
            value: function addEventProcessor(callback) {
                this._eventProcessors.push(callback);
                return this;
            }
        },
        {
            /**
   * @inheritDoc
   */ key: "setUser",
            value: function setUser(user) {
                // If null is passed we want to unset everything, but still define keys,
                // so that later down in the pipeline any existing values are cleared.
                this._user = user || {
                    email: undefined,
                    id: undefined,
                    ip_address: undefined,
                    segment: undefined,
                    username: undefined
                };
                if (this._session) {
                    (0,_session_js__WEBPACK_IMPORTED_MODULE_4__/* .updateSession */ .CT)(this._session, {
                        user: user
                    });
                }
                this._notifyScopeListeners();
                return this;
            }
        },
        {
            /**
   * @inheritDoc
   */ key: "getUser",
            value: function getUser() {
                return this._user;
            }
        },
        {
            /**
   * @inheritDoc
   */ key: "getRequestSession",
            value: function getRequestSession() {
                return this._requestSession;
            }
        },
        {
            /**
   * @inheritDoc
   */ key: "setRequestSession",
            value: function setRequestSession(requestSession) {
                this._requestSession = requestSession;
                return this;
            }
        },
        {
            /**
   * @inheritDoc
   */ key: "setTags",
            value: function setTags(tags) {
                this._tags = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, this._tags, tags);
                this._notifyScopeListeners();
                return this;
            }
        },
        {
            /**
   * @inheritDoc
   */ key: "setTag",
            value: function setTag(key, value) {
                this._tags = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, this._tags), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, key, value));
                this._notifyScopeListeners();
                return this;
            }
        },
        {
            /**
   * @inheritDoc
   */ key: "setExtras",
            value: function setExtras(extras) {
                this._extra = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, this._extra, extras);
                this._notifyScopeListeners();
                return this;
            }
        },
        {
            /**
   * @inheritDoc
   */ key: "setExtra",
            value: function setExtra(key, extra) {
                this._extra = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, this._extra), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, key, extra));
                this._notifyScopeListeners();
                return this;
            }
        },
        {
            /**
   * @inheritDoc
   */ key: "setFingerprint",
            value: function setFingerprint(fingerprint) {
                this._fingerprint = fingerprint;
                this._notifyScopeListeners();
                return this;
            }
        },
        {
            /**
   * @inheritDoc
   */ key: "setLevel",
            value: function setLevel(// eslint-disable-next-line deprecation/deprecation
            level) {
                this._level = level;
                this._notifyScopeListeners();
                return this;
            }
        },
        {
            /**
   * Sets the transaction name on the scope for future events.
   */ key: "setTransactionName",
            value: function setTransactionName(name) {
                this._transactionName = name;
                this._notifyScopeListeners();
                return this;
            }
        },
        {
            /**
   * @inheritDoc
   */ key: "setContext",
            value: function setContext(key, context) {
                if (context === null) {
                    // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
                    delete this._contexts[key];
                } else {
                    this._contexts[key] = context;
                }
                this._notifyScopeListeners();
                return this;
            }
        },
        {
            /**
   * Sets the Span on the scope.
   * @param span Span
   * @deprecated Instead of setting a span on a scope, use `startSpan()`/`startSpanManual()` instead.
   */ key: "setSpan",
            value: function setSpan(span) {
                this._span = span;
                this._notifyScopeListeners();
                return this;
            }
        },
        {
            /**
   * Returns the `Span` if there is one.
   * @deprecated Use `getActiveSpan()` instead.
   */ key: "getSpan",
            value: function getSpan() {
                return this._span;
            }
        },
        {
            /**
   * Returns the `Transaction` attached to the scope (if there is one).
   * @deprecated You should not rely on the transaction, but just use `startSpan()` APIs instead.
   */ key: "getTransaction",
            value: function getTransaction() {
                // Often, this span (if it exists at all) will be a transaction, but it's not guaranteed to be. Regardless, it will
                // have a pointer to the currently-active transaction.
                var span = this._span;
                // Cannot replace with getRootSpan because getRootSpan returns a span, not a transaction
                // Also, this method will be removed anyway.
                // eslint-disable-next-line deprecation/deprecation
                return span && span.transaction;
            }
        },
        {
            /**
   * @inheritDoc
   */ key: "setSession",
            value: function setSession(session) {
                if (!session) {
                    delete this._session;
                } else {
                    this._session = session;
                }
                this._notifyScopeListeners();
                return this;
            }
        },
        {
            /**
   * @inheritDoc
   */ key: "getSession",
            value: function getSession() {
                return this._session;
            }
        },
        {
            /**
   * @inheritDoc
   */ key: "update",
            value: function update(captureContext) {
                if (!captureContext) {
                    return this;
                }
                var scopeToMerge = typeof captureContext === "function" ? captureContext(this) : captureContext;
                if ((0,_swc_helpers_src_instanceof_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(scopeToMerge, Scope)) {
                    var scopeData = scopeToMerge.getScopeData();
                    this._tags = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, this._tags, scopeData.tags);
                    this._extra = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, this._extra, scopeData.extra);
                    this._contexts = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, this._contexts, scopeData.contexts);
                    if (scopeData.user && Object.keys(scopeData.user).length) {
                        this._user = scopeData.user;
                    }
                    if (scopeData.level) {
                        this._level = scopeData.level;
                    }
                    if (scopeData.fingerprint.length) {
                        this._fingerprint = scopeData.fingerprint;
                    }
                    if (scopeToMerge.getRequestSession()) {
                        this._requestSession = scopeToMerge.getRequestSession();
                    }
                    if (scopeData.propagationContext) {
                        this._propagationContext = scopeData.propagationContext;
                    }
                } else if ((0,_sentry_utils__WEBPACK_IMPORTED_MODULE_8__/* .isPlainObject */ .PO)(scopeToMerge)) {
                    var scopeContext = captureContext;
                    this._tags = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, this._tags, scopeContext.tags);
                    this._extra = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, this._extra, scopeContext.extra);
                    this._contexts = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, this._contexts, scopeContext.contexts);
                    if (scopeContext.user) {
                        this._user = scopeContext.user;
                    }
                    if (scopeContext.level) {
                        this._level = scopeContext.level;
                    }
                    if (scopeContext.fingerprint) {
                        this._fingerprint = scopeContext.fingerprint;
                    }
                    if (scopeContext.requestSession) {
                        this._requestSession = scopeContext.requestSession;
                    }
                    if (scopeContext.propagationContext) {
                        this._propagationContext = scopeContext.propagationContext;
                    }
                }
                return this;
            }
        },
        {
            /**
   * @inheritDoc
   */ key: "clear",
            value: function clear() {
                this._breadcrumbs = [];
                this._tags = {};
                this._extra = {};
                this._user = {};
                this._contexts = {};
                this._level = undefined;
                this._transactionName = undefined;
                this._fingerprint = undefined;
                this._requestSession = undefined;
                this._span = undefined;
                this._session = undefined;
                this._notifyScopeListeners();
                this._attachments = [];
                this._propagationContext = generatePropagationContext();
                return this;
            }
        },
        {
            /**
   * @inheritDoc
   */ key: "addBreadcrumb",
            value: function addBreadcrumb(breadcrumb, maxBreadcrumbs) {
                var maxCrumbs = typeof maxBreadcrumbs === "number" ? maxBreadcrumbs : DEFAULT_MAX_BREADCRUMBS;
                // No data has been changed, so don't notify scope listeners
                if (maxCrumbs <= 0) {
                    return this;
                }
                var mergedBreadcrumb = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
                    timestamp: (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_9__/* .dateTimestampInSeconds */ .yW)()
                }, breadcrumb);
                var breadcrumbs = this._breadcrumbs;
                breadcrumbs.push(mergedBreadcrumb);
                this._breadcrumbs = breadcrumbs.length > maxCrumbs ? breadcrumbs.slice(-maxCrumbs) : breadcrumbs;
                this._notifyScopeListeners();
                return this;
            }
        },
        {
            /**
   * @inheritDoc
   */ key: "getLastBreadcrumb",
            value: function getLastBreadcrumb() {
                return this._breadcrumbs[this._breadcrumbs.length - 1];
            }
        },
        {
            /**
   * @inheritDoc
   */ key: "clearBreadcrumbs",
            value: function clearBreadcrumbs() {
                this._breadcrumbs = [];
                this._notifyScopeListeners();
                return this;
            }
        },
        {
            /**
   * @inheritDoc
   */ key: "addAttachment",
            value: function addAttachment(attachment) {
                this._attachments.push(attachment);
                return this;
            }
        },
        {
            /**
   * @inheritDoc
   * @deprecated Use `getScopeData()` instead.
   */ key: "getAttachments",
            value: function getAttachments() {
                var data = this.getScopeData();
                return data.attachments;
            }
        },
        {
            /**
   * @inheritDoc
   */ key: "clearAttachments",
            value: function clearAttachments() {
                this._attachments = [];
                return this;
            }
        },
        {
            /** @inheritDoc */ key: "getScopeData",
            value: function getScopeData() {
                var ref = this, _breadcrumbs = ref._breadcrumbs, _attachments = ref._attachments, _contexts = ref._contexts, _tags = ref._tags, _extra = ref._extra, _user = ref._user, _level = ref._level, _fingerprint = ref._fingerprint, _eventProcessors = ref._eventProcessors, _propagationContext = ref._propagationContext, _sdkProcessingMetadata = ref._sdkProcessingMetadata, _transactionName = ref._transactionName, _span = ref._span;
                return {
                    breadcrumbs: _breadcrumbs,
                    attachments: _attachments,
                    contexts: _contexts,
                    tags: _tags,
                    extra: _extra,
                    user: _user,
                    level: _level,
                    fingerprint: _fingerprint || [],
                    eventProcessors: _eventProcessors,
                    propagationContext: _propagationContext,
                    sdkProcessingMetadata: _sdkProcessingMetadata,
                    transactionName: _transactionName,
                    span: _span
                };
            }
        },
        {
            /**
   * Applies data from the scope to the event and runs all event processors on it.
   *
   * @param event Event
   * @param hint Object containing additional information about the original exception, for use by the event processors.
   * @hidden
   * @deprecated Use `applyScopeDataToEvent()` directly
   */ key: "applyToEvent",
            value: function applyToEvent(event) {
                var hint = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, additionalEventProcessors = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : [];
                (0,_utils_applyScopeDataToEvent_js__WEBPACK_IMPORTED_MODULE_10__/* .applyScopeDataToEvent */ .gi)(event, this.getScopeData());
                // TODO (v8): Update this order to be: Global > Client > Scope
                var eventProcessors = (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(additionalEventProcessors).concat(// eslint-disable-next-line deprecation/deprecation
                (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_eventProcessors_js__WEBPACK_IMPORTED_MODULE_11__/* .getGlobalEventProcessors */ .fH)()), (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(this._eventProcessors));
                return (0,_eventProcessors_js__WEBPACK_IMPORTED_MODULE_11__/* .notifyEventProcessors */ .RP)(eventProcessors, event, hint);
            }
        },
        {
            /**
   * Add data which will be accessible during event processing but won't get sent to Sentry
   */ key: "setSDKProcessingMetadata",
            value: function setSDKProcessingMetadata(newData) {
                this._sdkProcessingMetadata = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, this._sdkProcessingMetadata, newData);
                return this;
            }
        },
        {
            /**
   * @inheritDoc
   */ key: "setPropagationContext",
            value: function setPropagationContext(context) {
                this._propagationContext = context;
                return this;
            }
        },
        {
            /**
   * @inheritDoc
   */ key: "getPropagationContext",
            value: function getPropagationContext() {
                return this._propagationContext;
            }
        },
        {
            /**
   * Capture an exception for this scope.
   *
   * @param exception The exception to capture.
   * @param hint Optinal additional data to attach to the Sentry event.
   * @returns the id of the captured Sentry event.
   */ key: "captureException",
            value: function captureException(exception, hint) {
                var eventId = hint && hint.event_id ? hint.event_id : (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_12__/* .uuid4 */ .DM)();
                if (!this._client) {
                    _sentry_utils__WEBPACK_IMPORTED_MODULE_13__/* .logger.warn */ .kg.warn("No client configured on scope - will not capture exception!");
                    return eventId;
                }
                var syntheticException = new Error("Sentry syntheticException");
                this._client.captureException(exception, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
                    originalException: exception,
                    syntheticException: syntheticException
                }, hint), {
                    event_id: eventId
                }), this);
                return eventId;
            }
        },
        {
            /**
   * Capture a message for this scope.
   *
   * @param message The message to capture.
   * @param level An optional severity level to report the message with.
   * @param hint Optional additional data to attach to the Sentry event.
   * @returns the id of the captured message.
   */ key: "captureMessage",
            value: function captureMessage(message, level, hint) {
                var eventId = hint && hint.event_id ? hint.event_id : (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_12__/* .uuid4 */ .DM)();
                if (!this._client) {
                    _sentry_utils__WEBPACK_IMPORTED_MODULE_13__/* .logger.warn */ .kg.warn("No client configured on scope - will not capture message!");
                    return eventId;
                }
                var syntheticException = new Error(message);
                this._client.captureMessage(message, level, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
                    originalException: message,
                    syntheticException: syntheticException
                }, hint), {
                    event_id: eventId
                }), this);
                return eventId;
            }
        },
        {
            /**
   * Captures a manually created event for this scope and sends it to Sentry.
   *
   * @param exception The event to capture.
   * @param hint Optional additional data to attach to the Sentry event.
   * @returns the id of the captured event.
   */ key: "captureEvent",
            value: function captureEvent(event, hint) {
                var eventId = hint && hint.event_id ? hint.event_id : (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_12__/* .uuid4 */ .DM)();
                if (!this._client) {
                    _sentry_utils__WEBPACK_IMPORTED_MODULE_13__/* .logger.warn */ .kg.warn("No client configured on scope - will not capture event!");
                    return eventId;
                }
                this._client.captureEvent(event, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, hint), {
                    event_id: eventId
                }), this);
                return eventId;
            }
        },
        {
            /**
   * This will be called on every set call.
   */ key: "_notifyScopeListeners",
            value: function _notifyScopeListeners() {
                var _this = this;
                // We need this check for this._notifyingListeners to be able to work on scope during updates
                // If this check is not here we'll produce endless recursion when something is done with the scope
                // during the callback.
                if (!this._notifyingListeners) {
                    this._notifyingListeners = true;
                    this._scopeListeners.forEach(function(callback) {
                        callback(_this);
                    });
                    this._notifyingListeners = false;
                }
            }
        }
    ], [
        {
            key: "clone",
            value: /**
   * Inherit values from the parent scope.
   * @deprecated Use `scope.clone()` and `new Scope()` instead.
   */ function clone(scope) {
                return scope ? scope.clone() : new Scope();
            }
        }
    ]);
    return Scope;
}();
/**
 * Get the global scope.
 * This scope is applied to _all_ events.
 */ function getGlobalScope() {
    if (!globalScope) {
        globalScope = new Scope();
    }
    return globalScope;
}
/**
 * This is mainly needed for tests.
 * DO NOT USE this, as this is an internal API and subject to change.
 * @hidden
 */ function setGlobalScope(scope) {
    globalScope = scope;
}
function generatePropagationContext() {
    return {
        traceId: (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_12__/* .uuid4 */ .DM)(),
        spanId: (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_12__/* .uuid4 */ .DM)().substring(16)
    };
}
 //# sourceMappingURL=scope.js.map


/***/ }),

/***/ 36463:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "CT": function() { return /* binding */ updateSession; },
/* harmony export */   "Hv": function() { return /* binding */ makeSession; },
/* harmony export */   "RJ": function() { return /* binding */ closeSession; }
/* harmony export */ });
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(96233);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(11591);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(27389);

/**
 * Creates a new `Session` object by setting certain default parameters. If optional @param context
 * is passed, the passed properties are applied to the session object.
 *
 * @param context (optional) additional properties to be applied to the returned session object
 *
 * @returns a new `Session` object
 */ function makeSession(context) {
    // Both timestamp and started are in seconds since the UNIX epoch.
    var startingTime = (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_0__/* .timestampInSeconds */ .ph)();
    var session = {
        sid: (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_1__/* .uuid4 */ .DM)(),
        init: true,
        timestamp: startingTime,
        started: startingTime,
        duration: 0,
        status: "ok",
        errors: 0,
        ignoreDuration: false,
        toJSON: function() {
            return sessionToJSON(session);
        }
    };
    if (context) {
        updateSession(session, context);
    }
    return session;
}
/**
 * Updates a session object with the properties passed in the context.
 *
 * Note that this function mutates the passed object and returns void.
 * (Had to do this instead of returning a new and updated session because closing and sending a session
 * makes an update to the session after it was passed to the sending logic.
 * @see BaseClient.captureSession )
 *
 * @param session the `Session` to update
 * @param context the `SessionContext` holding the properties that should be updated in @param session
 */ // eslint-disable-next-line complexity
function updateSession(session) {
    var context = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    if (context.user) {
        if (!session.ipAddress && context.user.ip_address) {
            session.ipAddress = context.user.ip_address;
        }
        if (!session.did && !context.did) {
            session.did = context.user.id || context.user.email || context.user.username;
        }
    }
    session.timestamp = context.timestamp || (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_0__/* .timestampInSeconds */ .ph)();
    if (context.abnormal_mechanism) {
        session.abnormal_mechanism = context.abnormal_mechanism;
    }
    if (context.ignoreDuration) {
        session.ignoreDuration = context.ignoreDuration;
    }
    if (context.sid) {
        // Good enough uuid validation. — Kamil
        session.sid = context.sid.length === 32 ? context.sid : (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_1__/* .uuid4 */ .DM)();
    }
    if (context.init !== undefined) {
        session.init = context.init;
    }
    if (!session.did && context.did) {
        session.did = "".concat(context.did);
    }
    if (typeof context.started === "number") {
        session.started = context.started;
    }
    if (session.ignoreDuration) {
        session.duration = undefined;
    } else if (typeof context.duration === "number") {
        session.duration = context.duration;
    } else {
        var duration = session.timestamp - session.started;
        session.duration = duration >= 0 ? duration : 0;
    }
    if (context.release) {
        session.release = context.release;
    }
    if (context.environment) {
        session.environment = context.environment;
    }
    if (!session.ipAddress && context.ipAddress) {
        session.ipAddress = context.ipAddress;
    }
    if (!session.userAgent && context.userAgent) {
        session.userAgent = context.userAgent;
    }
    if (typeof context.errors === "number") {
        session.errors = context.errors;
    }
    if (context.status) {
        session.status = context.status;
    }
}
/**
 * Closes a session by setting its status and updating the session object with it.
 * Internally calls `updateSession` to update the passed session object.
 *
 * Note that this function mutates the passed session (@see updateSession for explanation).
 *
 * @param session the `Session` object to be closed
 * @param status the `SessionStatus` with which the session was closed. If you don't pass a status,
 *               this function will keep the previously set status, unless it was `'ok'` in which case
 *               it is changed to `'exited'`.
 */ function closeSession(session, status) {
    var context = {};
    if (status) {
        context = {
            status: status
        };
    } else if (session.status === "ok") {
        context = {
            status: "exited"
        };
    }
    updateSession(session, context);
}
/**
 * Serializes a passed session object to a JSON object with a slightly different structure.
 * This is necessary because the Sentry backend requires a slightly different schema of a session
 * than the one the JS SDKs use internally.
 *
 * @param session the session to be converted
 *
 * @returns a JSON object of the passed session
 */ function sessionToJSON(session) {
    return (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_2__/* .dropUndefinedKeys */ .Jr)({
        sid: "".concat(session.sid),
        init: session.init,
        // Make sure that sec is converted to ms for date constructor
        started: new Date(session.started * 1000).toISOString(),
        timestamp: new Date(session.timestamp * 1000).toISOString(),
        status: session.status,
        errors: session.errors,
        did: typeof session.did === "number" || typeof session.did === "string" ? "".concat(session.did) : undefined,
        duration: session.duration,
        abnormal_mechanism: session.abnormal_mechanism,
        attrs: {
            release: session.release,
            environment: session.environment,
            ip_address: session.ipAddress,
            user_agent: session.userAgent
        }
    });
}
 //# sourceMappingURL=session.js.map


/***/ }),

/***/ 63055:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "_": function() { return /* binding */ getDynamicSamplingContextFromClient; },
/* harmony export */   "j": function() { return /* binding */ getDynamicSamplingContextFromSpan; }
/* harmony export */ });
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(27389);
/* harmony import */ var _constants_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(96699);
/* harmony import */ var _exports_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(77668);
/* harmony import */ var _utils_getRootSpan_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(27606);
/* harmony import */ var _utils_spanUtils_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(76190);





/**
 * Creates a dynamic sampling context from a client.
 *
 * Dispatches the `createDsc` lifecycle hook as a side effect.
 */ function getDynamicSamplingContextFromClient(trace_id, client, scope) {
    var options = client.getOptions();
    var ref = client.getDsn() || {}, public_key = ref.publicKey;
    // TODO(v8): Remove segment from User
    // eslint-disable-next-line deprecation/deprecation
    var ref1 = scope && scope.getUser() || {}, user_segment = ref1.segment;
    var dsc = (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_0__/* .dropUndefinedKeys */ .Jr)({
        environment: options.environment || _constants_js__WEBPACK_IMPORTED_MODULE_1__/* .DEFAULT_ENVIRONMENT */ .J,
        release: options.release,
        user_segment: user_segment,
        public_key: public_key,
        trace_id: trace_id
    });
    client.emit && client.emit("createDsc", dsc);
    return dsc;
}
/**
 * A Span with a frozen dynamic sampling context.
 */ /**
 * Creates a dynamic sampling context from a span (and client and scope)
 *
 * @param span the span from which a few values like the root span name and sample rate are extracted.
 *
 * @returns a dynamic sampling context
 */ function getDynamicSamplingContextFromSpan(span) {
    var client = (0,_exports_js__WEBPACK_IMPORTED_MODULE_2__/* .getClient */ .s3)();
    if (!client) {
        return {};
    }
    // passing emit=false here to only emit later once the DSC is actually populated
    var dsc = getDynamicSamplingContextFromClient((0,_utils_spanUtils_js__WEBPACK_IMPORTED_MODULE_3__/* .spanToJSON */ .XU)(span).trace_id || "", client, (0,_exports_js__WEBPACK_IMPORTED_MODULE_2__/* .getCurrentScope */ .nZ)());
    // TODO (v8): Remove v7FrozenDsc as a Transaction will no longer have _frozenDynamicSamplingContext
    var txn = (0,_utils_getRootSpan_js__WEBPACK_IMPORTED_MODULE_4__/* .getRootSpan */ .G)(span);
    if (!txn) {
        return dsc;
    }
    // TODO (v8): Remove v7FrozenDsc as a Transaction will no longer have _frozenDynamicSamplingContext
    // For now we need to avoid breaking users who directly created a txn with a DSC, where this field is still set.
    // @see Transaction class constructor
    var v7FrozenDsc = txn && txn._frozenDynamicSamplingContext;
    if (v7FrozenDsc) {
        return v7FrozenDsc;
    }
    // TODO (v8): Replace txn.metadata with txn.attributes[]
    // We can't do this yet because attributes aren't always set yet.
    // eslint-disable-next-line deprecation/deprecation
    var _metadata = txn.metadata, maybeSampleRate = _metadata.sampleRate, source = _metadata.source;
    if (maybeSampleRate != null) {
        dsc.sample_rate = "".concat(maybeSampleRate);
    }
    // We don't want to have a transaction name in the DSC if the source is "url" because URLs might contain PII
    var jsonSpan = (0,_utils_spanUtils_js__WEBPACK_IMPORTED_MODULE_3__/* .spanToJSON */ .XU)(txn);
    // after JSON conversion, txn.name becomes jsonSpan.description
    if (source && source !== "url") {
        dsc.transaction = jsonSpan.description;
    }
    dsc.sampled = String((0,_utils_spanUtils_js__WEBPACK_IMPORTED_MODULE_3__/* .spanIsSampled */ .Tt)(txn));
    client.emit && client.emit("createDsc", dsc);
    return dsc;
}
 //# sourceMappingURL=dynamicSamplingContext.js.map


/***/ }),

/***/ 56559:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "gi": function() { return /* binding */ applyScopeDataToEvent; },
/* harmony export */   "yo": function() { return /* binding */ mergeScopeData; }
/* harmony export */ });
/* unused harmony export mergeAndOverwriteScopeData */
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(36305);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(27389);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(11591);
/* harmony import */ var _tracing_dynamicSamplingContext_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(63055);
/* harmony import */ var _getRootSpan_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(27606);
/* harmony import */ var _spanUtils_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(76190);






/**
 * Applies data from the scope to the event and runs all event processors on it.
 */ function applyScopeDataToEvent(event, data) {
    var fingerprint = data.fingerprint, span = data.span, breadcrumbs = data.breadcrumbs, sdkProcessingMetadata = data.sdkProcessingMetadata;
    // Apply general data
    applyDataToEvent(event, data);
    // We want to set the trace context for normal events only if there isn't already
    // a trace context on the event. There is a product feature in place where we link
    // errors with transaction and it relies on that.
    if (span) {
        applySpanToEvent(event, span);
    }
    applyFingerprintToEvent(event, fingerprint);
    applyBreadcrumbsToEvent(event, breadcrumbs);
    applySdkMetadataToEvent(event, sdkProcessingMetadata);
}
/** Merge data of two scopes together. */ function mergeScopeData(data, mergeData) {
    var extra = mergeData.extra, tags = mergeData.tags, user = mergeData.user, contexts = mergeData.contexts, level = mergeData.level, sdkProcessingMetadata = mergeData.sdkProcessingMetadata, breadcrumbs = mergeData.breadcrumbs, fingerprint = mergeData.fingerprint, eventProcessors = mergeData.eventProcessors, attachments = mergeData.attachments, propagationContext = mergeData.propagationContext, // eslint-disable-next-line deprecation/deprecation
    transactionName = mergeData.transactionName, span = mergeData.span;
    mergeAndOverwriteScopeData(data, "extra", extra);
    mergeAndOverwriteScopeData(data, "tags", tags);
    mergeAndOverwriteScopeData(data, "user", user);
    mergeAndOverwriteScopeData(data, "contexts", contexts);
    mergeAndOverwriteScopeData(data, "sdkProcessingMetadata", sdkProcessingMetadata);
    if (level) {
        data.level = level;
    }
    if (transactionName) {
        // eslint-disable-next-line deprecation/deprecation
        data.transactionName = transactionName;
    }
    if (span) {
        data.span = span;
    }
    if (breadcrumbs.length) {
        data.breadcrumbs = (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(data.breadcrumbs).concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(breadcrumbs));
    }
    if (fingerprint.length) {
        data.fingerprint = (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(data.fingerprint).concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(fingerprint));
    }
    if (eventProcessors.length) {
        data.eventProcessors = (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(data.eventProcessors).concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(eventProcessors));
    }
    if (attachments.length) {
        data.attachments = (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(data.attachments).concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(attachments));
    }
    data.propagationContext = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, data.propagationContext, propagationContext);
}
/**
 * Merges certain scope data. Undefined values will overwrite any existing values.
 * Exported only for tests.
 */ function mergeAndOverwriteScopeData(data, prop, mergeVal) {
    if (mergeVal && Object.keys(mergeVal).length) {
        // Clone object
        data[prop] = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, data[prop]);
        for(var key in mergeVal){
            if (Object.prototype.hasOwnProperty.call(mergeVal, key)) {
                data[prop][key] = mergeVal[key];
            }
        }
    }
}
function applyDataToEvent(event, data) {
    var extra = data.extra, tags = data.tags, user = data.user, contexts = data.contexts, level = data.level, // eslint-disable-next-line deprecation/deprecation
    transactionName = data.transactionName;
    var cleanedExtra = (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_2__/* .dropUndefinedKeys */ .Jr)(extra);
    if (cleanedExtra && Object.keys(cleanedExtra).length) {
        event.extra = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, cleanedExtra, event.extra);
    }
    var cleanedTags = (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_2__/* .dropUndefinedKeys */ .Jr)(tags);
    if (cleanedTags && Object.keys(cleanedTags).length) {
        event.tags = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, cleanedTags, event.tags);
    }
    var cleanedUser = (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_2__/* .dropUndefinedKeys */ .Jr)(user);
    if (cleanedUser && Object.keys(cleanedUser).length) {
        event.user = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, cleanedUser, event.user);
    }
    var cleanedContexts = (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_2__/* .dropUndefinedKeys */ .Jr)(contexts);
    if (cleanedContexts && Object.keys(cleanedContexts).length) {
        event.contexts = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, cleanedContexts, event.contexts);
    }
    if (level) {
        event.level = level;
    }
    if (transactionName) {
        event.transaction = transactionName;
    }
}
function applyBreadcrumbsToEvent(event, breadcrumbs) {
    var mergedBreadcrumbs = (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(event.breadcrumbs || []).concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(breadcrumbs));
    event.breadcrumbs = mergedBreadcrumbs.length ? mergedBreadcrumbs : undefined;
}
function applySdkMetadataToEvent(event, sdkProcessingMetadata) {
    event.sdkProcessingMetadata = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, event.sdkProcessingMetadata, sdkProcessingMetadata);
}
function applySpanToEvent(event, span) {
    event.contexts = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({
        trace: (0,_spanUtils_js__WEBPACK_IMPORTED_MODULE_3__/* .spanToTraceContext */ .wy)(span)
    }, event.contexts);
    var rootSpan = (0,_getRootSpan_js__WEBPACK_IMPORTED_MODULE_4__/* .getRootSpan */ .G)(span);
    if (rootSpan) {
        event.sdkProcessingMetadata = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({
            dynamicSamplingContext: (0,_tracing_dynamicSamplingContext_js__WEBPACK_IMPORTED_MODULE_5__/* .getDynamicSamplingContextFromSpan */ .j)(span)
        }, event.sdkProcessingMetadata);
        var transactionName = (0,_spanUtils_js__WEBPACK_IMPORTED_MODULE_3__/* .spanToJSON */ .XU)(rootSpan).description;
        if (transactionName) {
            event.tags = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({
                transaction: transactionName
            }, event.tags);
        }
    }
}
/**
 * Applies fingerprint from the scope to the event if there's one,
 * uses message if there's one instead or get rid of empty fingerprint
 */ function applyFingerprintToEvent(event, fingerprint) {
    // Make sure it's an array first and we actually have something in place
    event.fingerprint = event.fingerprint ? (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_6__/* .arrayify */ .lE)(event.fingerprint) : [];
    // If we have something on the scope, then merge it with event
    if (fingerprint) {
        event.fingerprint = event.fingerprint.concat(fingerprint);
    }
    // If we have no data at all, remove empty array default
    if (event.fingerprint && !event.fingerprint.length) {
        delete event.fingerprint;
    }
}
 //# sourceMappingURL=applyScopeDataToEvent.js.map


/***/ }),

/***/ 27606:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "G": function() { return /* binding */ getRootSpan; }
/* harmony export */ });
/**
 * Returns the root span of a given span.
 *
 * As long as we use `Transaction`s internally, the returned root span
 * will be a `Transaction` but be aware that this might change in the future.
 *
 * If the given span has no root span or transaction, `undefined` is returned.
 */ function getRootSpan(span) {
    // TODO (v8): Remove this check and just return span
    // eslint-disable-next-line deprecation/deprecation
    return span.transaction;
}
 //# sourceMappingURL=getRootSpan.js.map


/***/ }),

/***/ 70271:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "R": function() { return /* binding */ prepareEvent; },
/* harmony export */   "U0": function() { return /* binding */ parseEventHintOrCaptureContext; }
/* harmony export */ });
/* unused harmony exports applyDebugIds, applyDebugMeta */
/* harmony import */ var _swc_helpers_src_instanceof_mjs__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(82670);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(36305);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(11591);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(96233);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(68813);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(74672);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(92276);
/* harmony import */ var _constants_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(96699);
/* harmony import */ var _eventProcessors_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(38126);
/* harmony import */ var _scope_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(29791);
/* harmony import */ var _applyScopeDataToEvent_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(56559);
/* harmony import */ var _spanUtils_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(76190);










/**
 * This type makes sure that we get either a CaptureContext, OR an EventHint.
 * It does not allow mixing them, which could lead to unexpected outcomes, e.g. this is disallowed:
 * { user: { id: '123' }, mechanism: { handled: false } }
 */ /**
 * Adds common information to events.
 *
 * The information includes release and environment from `options`,
 * breadcrumbs and context (extra, tags and user) from the scope.
 *
 * Information that is already present in the event is never overwritten. For
 * nested objects, such as the context, keys are merged.
 *
 * Note: This also triggers callbacks for `addGlobalEventProcessor`, but not `beforeSend`.
 *
 * @param event The original event.
 * @param hint May contain additional information about the original exception.
 * @param scope A scope containing event metadata.
 * @returns A new event with more information.
 * @hidden
 */ function prepareEvent(options, event, hint, scope, client, isolationScope) {
    var _normalizeDepth = options.normalizeDepth, normalizeDepth = _normalizeDepth === void 0 ? 3 : _normalizeDepth, _normalizeMaxBreadth = options.normalizeMaxBreadth, normalizeMaxBreadth = _normalizeMaxBreadth === void 0 ? 1000 : _normalizeMaxBreadth;
    var prepared = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, event), {
        event_id: event.event_id || hint.event_id || (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_2__/* .uuid4 */ .DM)(),
        timestamp: event.timestamp || (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_3__/* .dateTimestampInSeconds */ .yW)()
    });
    var integrations = hint.integrations || options.integrations.map(function(i) {
        return i.name;
    });
    applyClientOptions(prepared, options);
    applyIntegrationsMetadata(prepared, integrations);
    // Only put debug IDs onto frames for error events.
    if (event.type === undefined) {
        applyDebugIds(prepared, options.stackParser);
    }
    // If we have scope given to us, use it as the base for further modifications.
    // This allows us to prevent unnecessary copying of data if `captureContext` is not provided.
    var finalScope = getFinalScope(scope, hint.captureContext);
    if (hint.mechanism) {
        (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_2__/* .addExceptionMechanism */ .EG)(prepared, hint.mechanism);
    }
    var clientEventProcessors = client && client.getEventProcessors ? client.getEventProcessors() : [];
    // This should be the last thing called, since we want that
    // {@link Hub.addEventProcessor} gets the finished prepared event.
    // Merge scope data together
    var data = (0,_scope_js__WEBPACK_IMPORTED_MODULE_4__/* .getGlobalScope */ .lW)().getScopeData();
    if (isolationScope) {
        var isolationData = isolationScope.getScopeData();
        (0,_applyScopeDataToEvent_js__WEBPACK_IMPORTED_MODULE_5__/* .mergeScopeData */ .yo)(data, isolationData);
    }
    if (finalScope) {
        var finalScopeData = finalScope.getScopeData();
        (0,_applyScopeDataToEvent_js__WEBPACK_IMPORTED_MODULE_5__/* .mergeScopeData */ .yo)(data, finalScopeData);
    }
    var attachments = (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(hint.attachments || []).concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(data.attachments));
    if (attachments.length) {
        hint.attachments = attachments;
    }
    (0,_applyScopeDataToEvent_js__WEBPACK_IMPORTED_MODULE_5__/* .applyScopeDataToEvent */ .gi)(prepared, data);
    // TODO (v8): Update this order to be: Global > Client > Scope
    var eventProcessors = (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(clientEventProcessors).concat(// eslint-disable-next-line deprecation/deprecation
    (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_eventProcessors_js__WEBPACK_IMPORTED_MODULE_7__/* .getGlobalEventProcessors */ .fH)()), // Run scope event processors _after_ all other processors
    (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(data.eventProcessors));
    var result = (0,_eventProcessors_js__WEBPACK_IMPORTED_MODULE_7__/* .notifyEventProcessors */ .RP)(eventProcessors, prepared, hint);
    return result.then(function(evt) {
        if (evt) {
            // We apply the debug_meta field only after all event processors have ran, so that if any event processors modified
            // file names (e.g.the RewriteFrames integration) the filename -> debug ID relationship isn't destroyed.
            // This should not cause any PII issues, since we're only moving data that is already on the event and not adding
            // any new data
            applyDebugMeta(evt);
        }
        if (typeof normalizeDepth === "number" && normalizeDepth > 0) {
            return normalizeEvent(evt, normalizeDepth, normalizeMaxBreadth);
        }
        return evt;
    });
}
/**
 *  Enhances event using the client configuration.
 *  It takes care of all "static" values like environment, release and `dist`,
 *  as well as truncating overly long values.
 * @param event event instance to be enhanced
 */ function applyClientOptions(event, options) {
    var environment = options.environment, release = options.release, dist = options.dist, _maxValueLength = options.maxValueLength, maxValueLength = _maxValueLength === void 0 ? 250 : _maxValueLength;
    if (!("environment" in event)) {
        event.environment = "environment" in options ? environment : _constants_js__WEBPACK_IMPORTED_MODULE_8__/* .DEFAULT_ENVIRONMENT */ .J;
    }
    if (event.release === undefined && release !== undefined) {
        event.release = release;
    }
    if (event.dist === undefined && dist !== undefined) {
        event.dist = dist;
    }
    if (event.message) {
        event.message = (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_9__/* .truncate */ .$G)(event.message, maxValueLength);
    }
    var exception = event.exception && event.exception.values && event.exception.values[0];
    if (exception && exception.value) {
        exception.value = (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_9__/* .truncate */ .$G)(exception.value, maxValueLength);
    }
    var request = event.request;
    if (request && request.url) {
        request.url = (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_9__/* .truncate */ .$G)(request.url, maxValueLength);
    }
}
var debugIdStackParserCache = new WeakMap();
/**
 * Puts debug IDs into the stack frames of an error event.
 */ function applyDebugIds(event, stackParser) {
    var debugIdMap = _sentry_utils__WEBPACK_IMPORTED_MODULE_10__/* .GLOBAL_OBJ._sentryDebugIds */ .n2._sentryDebugIds;
    if (!debugIdMap) {
        return;
    }
    var debugIdStackFramesCache;
    var cachedDebugIdStackFrameCache = debugIdStackParserCache.get(stackParser);
    if (cachedDebugIdStackFrameCache) {
        debugIdStackFramesCache = cachedDebugIdStackFrameCache;
    } else {
        debugIdStackFramesCache = new Map();
        debugIdStackParserCache.set(stackParser, debugIdStackFramesCache);
    }
    // Build a map of filename -> debug_id
    var filenameDebugIdMap = Object.keys(debugIdMap).reduce(function(acc, debugIdStackTrace) {
        var parsedStack;
        var cachedParsedStack = debugIdStackFramesCache.get(debugIdStackTrace);
        if (cachedParsedStack) {
            parsedStack = cachedParsedStack;
        } else {
            parsedStack = stackParser(debugIdStackTrace);
            debugIdStackFramesCache.set(debugIdStackTrace, parsedStack);
        }
        for(var i = parsedStack.length - 1; i >= 0; i--){
            var stackFrame = parsedStack[i];
            if (stackFrame.filename) {
                acc[stackFrame.filename] = debugIdMap[debugIdStackTrace];
                break;
            }
        }
        return acc;
    }, {});
    try {
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        event.exception.values.forEach(function(exception) {
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            exception.stacktrace.frames.forEach(function(frame) {
                if (frame.filename) {
                    frame.debug_id = filenameDebugIdMap[frame.filename];
                }
            });
        });
    } catch (e) {
    // To save bundle size we're just try catching here instead of checking for the existence of all the different objects.
    }
}
/**
 * Moves debug IDs from the stack frames of an error event into the debug_meta field.
 */ function applyDebugMeta(event) {
    // Extract debug IDs and filenames from the stack frames on the event.
    var filenameDebugIdMap = {};
    try {
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        event.exception.values.forEach(function(exception) {
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            exception.stacktrace.frames.forEach(function(frame) {
                if (frame.debug_id) {
                    if (frame.abs_path) {
                        filenameDebugIdMap[frame.abs_path] = frame.debug_id;
                    } else if (frame.filename) {
                        filenameDebugIdMap[frame.filename] = frame.debug_id;
                    }
                    delete frame.debug_id;
                }
            });
        });
    } catch (e) {
    // To save bundle size we're just try catching here instead of checking for the existence of all the different objects.
    }
    if (Object.keys(filenameDebugIdMap).length === 0) {
        return;
    }
    // Fill debug_meta information
    event.debug_meta = event.debug_meta || {};
    event.debug_meta.images = event.debug_meta.images || [];
    var images = event.debug_meta.images;
    Object.keys(filenameDebugIdMap).forEach(function(filename) {
        images.push({
            type: "sourcemap",
            code_file: filename,
            debug_id: filenameDebugIdMap[filename]
        });
    });
}
/**
 * This function adds all used integrations to the SDK info in the event.
 * @param event The event that will be filled with all integrations.
 */ function applyIntegrationsMetadata(event, integrationNames) {
    if (integrationNames.length > 0) {
        event.sdk = event.sdk || {};
        event.sdk.integrations = (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(event.sdk.integrations || []).concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(integrationNames));
    }
}
/**
 * Applies `normalize` function on necessary `Event` attributes to make them safe for serialization.
 * Normalized keys:
 * - `breadcrumbs.data`
 * - `user`
 * - `contexts`
 * - `extra`
 * @param event Event
 * @returns Normalized event
 */ function normalizeEvent(event, depth, maxBreadth) {
    if (!event) {
        return null;
    }
    var normalized = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, event, event.breadcrumbs && {
        breadcrumbs: event.breadcrumbs.map(function(b) {
            return (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, b, b.data && {
                data: (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_11__/* .normalize */ .Fv)(b.data, depth, maxBreadth)
            });
        })
    }, event.user && {
        user: (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_11__/* .normalize */ .Fv)(event.user, depth, maxBreadth)
    }, event.contexts && {
        contexts: (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_11__/* .normalize */ .Fv)(event.contexts, depth, maxBreadth)
    }, event.extra && {
        extra: (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_11__/* .normalize */ .Fv)(event.extra, depth, maxBreadth)
    });
    // event.contexts.trace stores information about a Transaction. Similarly,
    // event.spans[] stores information about child Spans. Given that a
    // Transaction is conceptually a Span, normalization should apply to both
    // Transactions and Spans consistently.
    // For now the decision is to skip normalization of Transactions and Spans,
    // so this block overwrites the normalized event to add back the original
    // Transaction information prior to normalization.
    if (event.contexts && event.contexts.trace && normalized.contexts) {
        normalized.contexts.trace = event.contexts.trace;
        // event.contexts.trace.data may contain circular/dangerous data so we need to normalize it
        if (event.contexts.trace.data) {
            normalized.contexts.trace.data = (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_11__/* .normalize */ .Fv)(event.contexts.trace.data, depth, maxBreadth);
        }
    }
    // event.spans[].data may contain circular/dangerous data so we need to normalize it
    if (event.spans) {
        normalized.spans = event.spans.map(function(span) {
            var data = (0,_spanUtils_js__WEBPACK_IMPORTED_MODULE_12__/* .spanToJSON */ .XU)(span).data;
            if (data) {
                // This is a bit weird, as we generally have `Span` instances here, but to be safe we do not assume so
                // eslint-disable-next-line deprecation/deprecation
                span.data = (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_11__/* .normalize */ .Fv)(data, depth, maxBreadth);
            }
            return span;
        });
    }
    return normalized;
}
function getFinalScope(scope, captureContext) {
    if (!captureContext) {
        return scope;
    }
    var finalScope = scope ? scope.clone() : new _scope_js__WEBPACK_IMPORTED_MODULE_4__/* .Scope */ .sX();
    finalScope.update(captureContext);
    return finalScope;
}
/**
 * Parse either an `EventHint` directly, or convert a `CaptureContext` to an `EventHint`.
 * This is used to allow to update method signatures that used to accept a `CaptureContext` but should now accept an `EventHint`.
 */ function parseEventHintOrCaptureContext(hint) {
    if (!hint) {
        return undefined;
    }
    // If you pass a Scope or `() => Scope` as CaptureContext, we just return this as captureContext
    if (hintIsScopeOrFunction(hint)) {
        return {
            captureContext: hint
        };
    }
    if (hintIsScopeContext(hint)) {
        return {
            captureContext: hint
        };
    }
    return hint;
}
function hintIsScopeOrFunction(hint) {
    return (0,_swc_helpers_src_instanceof_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)(hint, _scope_js__WEBPACK_IMPORTED_MODULE_4__/* .Scope */ .sX) || typeof hint === "function";
}
var captureContextKeys = [
    "user",
    "level",
    "extra",
    "contexts",
    "tags",
    "fingerprint",
    "requestSession",
    "propagationContext", 
];
function hintIsScopeContext(hint) {
    return Object.keys(hint).some(function(key) {
        return captureContextKeys.includes(key);
    });
}
 //# sourceMappingURL=prepareEvent.js.map


/***/ }),

/***/ 76190:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$k": function() { return /* binding */ spanTimeInputToSeconds; },
/* harmony export */   "Hb": function() { return /* binding */ spanToTraceHeader; },
/* harmony export */   "Tt": function() { return /* binding */ spanIsSampled; },
/* harmony export */   "XU": function() { return /* binding */ spanToJSON; },
/* harmony export */   "i0": function() { return /* binding */ TRACE_FLAG_SAMPLED; },
/* harmony export */   "ve": function() { return /* binding */ TRACE_FLAG_NONE; },
/* harmony export */   "wy": function() { return /* binding */ spanToTraceContext; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_instanceof_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(82670);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(27389);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(84907);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(96233);


// These are aligned with OpenTelemetry trace flags
var TRACE_FLAG_NONE = 0x0;
var TRACE_FLAG_SAMPLED = 0x1;
/**
 * Convert a span to a trace context, which can be sent as the `trace` context in an event.
 */ function spanToTraceContext(span) {
    var ref = span.spanContext(), span_id = ref.spanId, trace_id = ref.traceId;
    var ref1 = spanToJSON(span), data = ref1.data, op = ref1.op, parent_span_id = ref1.parent_span_id, status = ref1.status, tags = ref1.tags, origin = ref1.origin;
    return (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_0__/* .dropUndefinedKeys */ .Jr)({
        data: data,
        op: op,
        parent_span_id: parent_span_id,
        span_id: span_id,
        status: status,
        tags: tags,
        trace_id: trace_id,
        origin: origin
    });
}
/**
 * Convert a Span to a Sentry trace header.
 */ function spanToTraceHeader(span) {
    var ref = span.spanContext(), traceId = ref.traceId, spanId = ref.spanId;
    var sampled = spanIsSampled(span);
    return (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_1__/* .generateSentryTraceHeader */ .$p)(traceId, spanId, sampled);
}
/**
 * Convert a span time input intp a timestamp in seconds.
 */ function spanTimeInputToSeconds(input) {
    if (typeof input === "number") {
        return ensureTimestampInSeconds(input);
    }
    if (Array.isArray(input)) {
        // See {@link HrTime} for the array-based time format
        return input[0] + input[1] / 1e9;
    }
    if ((0,_swc_helpers_src_instanceof_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(input, Date)) {
        return ensureTimestampInSeconds(input.getTime());
    }
    return (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_3__/* .timestampInSeconds */ .ph)();
}
/**
 * Converts a timestamp to second, if it was in milliseconds, or keeps it as second.
 */ function ensureTimestampInSeconds(timestamp) {
    var isMs = timestamp > 9999999999;
    return isMs ? timestamp / 1000 : timestamp;
}
/**
 * Convert a span to a JSON representation.
 * Note that all fields returned here are optional and need to be guarded against.
 *
 * Note: Because of this, we currently have a circular type dependency (which we opted out of in package.json).
 * This is not avoidable as we need `spanToJSON` in `spanUtils.ts`, which in turn is needed by `span.ts` for backwards compatibility.
 * And `spanToJSON` needs the Span class from `span.ts` to check here.
 * TODO v8: When we remove the deprecated stuff from `span.ts`, we can remove the circular dependency again.
 */ function spanToJSON(span) {
    if (spanIsSpanClass(span)) {
        return span.getSpanJSON();
    }
    // Fallback: We also check for `.toJSON()` here...
    // eslint-disable-next-line deprecation/deprecation
    if (typeof span.toJSON === "function") {
        // eslint-disable-next-line deprecation/deprecation
        return span.toJSON();
    }
    return {};
}
/**
 * Sadly, due to circular dependency checks we cannot actually import the Span class here and check for instanceof.
 * :( So instead we approximate this by checking if it has the `getSpanJSON` method.
 */ function spanIsSpanClass(span) {
    return typeof span.getSpanJSON === "function";
}
/**
 * Returns true if a span is sampled.
 * In most cases, you should just use `span.isRecording()` instead.
 * However, this has a slightly different semantic, as it also returns false if the span is finished.
 * So in the case where this distinction is important, use this method.
 */ function spanIsSampled(span) {
    // We align our trace flags with the ones OpenTelemetry use
    // So we also check for sampled the same way they do.
    var traceFlags = span.spanContext().traceFlags;
    // eslint-disable-next-line no-bitwise
    return Boolean(traceFlags & TRACE_FLAG_SAMPLED);
}
 //# sourceMappingURL=spanUtils.js.map


/***/ }),

/***/ 63935:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "J": function() { return /* binding */ SDK_VERSION; }
/* harmony export */ });
var SDK_VERSION = "7.120.4";
 //# sourceMappingURL=version.js.map


/***/ }),

/***/ 50257:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "EN": function() { return /* binding */ baggageHeaderToDynamicSamplingContext; },
/* harmony export */   "IQ": function() { return /* binding */ dynamicSamplingContextToSentryBaggageHeader; },
/* harmony export */   "bU": function() { return /* binding */ BAGGAGE_HEADER_NAME; }
/* harmony export */ });
/* unused harmony exports MAX_BAGGAGE_STRING_LENGTH, SENTRY_BAGGAGE_KEY_PREFIX, SENTRY_BAGGAGE_KEY_PREFIX_REGEX */
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(10253);
/* harmony import */ var _debug_build_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(35614);
/* harmony import */ var _is_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(74020);
/* harmony import */ var _logger_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(92957);




var BAGGAGE_HEADER_NAME = "baggage";
var SENTRY_BAGGAGE_KEY_PREFIX = "sentry-";
var SENTRY_BAGGAGE_KEY_PREFIX_REGEX = /^sentry-/;
/**
 * Max length of a serialized baggage string
 *
 * https://www.w3.org/TR/baggage/#limits
 */ var MAX_BAGGAGE_STRING_LENGTH = 8192;
/**
 * Takes a baggage header and turns it into Dynamic Sampling Context, by extracting all the "sentry-" prefixed values
 * from it.
 *
 * @param baggageHeader A very bread definition of a baggage header as it might appear in various frameworks.
 * @returns The Dynamic Sampling Context that was found on `baggageHeader`, if there was any, `undefined` otherwise.
 */ function baggageHeaderToDynamicSamplingContext(// Very liberal definition of what any incoming header might look like
baggageHeader) {
    if (!(0,_is_js__WEBPACK_IMPORTED_MODULE_0__/* .isString */ .HD)(baggageHeader) && !Array.isArray(baggageHeader)) {
        return undefined;
    }
    // Intermediary object to store baggage key value pairs of incoming baggage headers on.
    // It is later used to read Sentry-DSC-values from.
    var baggageObject = {};
    if (Array.isArray(baggageHeader)) {
        // Combine all baggage headers into one object containing the baggage values so we can later read the Sentry-DSC-values from it
        baggageObject = baggageHeader.reduce(function(acc, curr) {
            var currBaggageObject = baggageHeaderToObject(curr);
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = Object.keys(currBaggageObject)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var key = _step.value;
                    acc[key] = currBaggageObject[key];
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
            return acc;
        }, {});
    } else {
        // Return undefined if baggage header is an empty string (technically an empty baggage header is not spec conform but
        // this is how we choose to handle it)
        if (!baggageHeader) {
            return undefined;
        }
        baggageObject = baggageHeaderToObject(baggageHeader);
    }
    // Read all "sentry-" prefixed values out of the baggage object and put it onto a dynamic sampling context object.
    var dynamicSamplingContext = Object.entries(baggageObject).reduce(function(acc, param) {
        var _param = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(param, 2), key = _param[0], value = _param[1];
        if (key.match(SENTRY_BAGGAGE_KEY_PREFIX_REGEX)) {
            var nonPrefixedKey = key.slice(SENTRY_BAGGAGE_KEY_PREFIX.length);
            acc[nonPrefixedKey] = value;
        }
        return acc;
    }, {});
    // Only return a dynamic sampling context object if there are keys in it.
    // A keyless object means there were no sentry values on the header, which means that there is no DSC.
    if (Object.keys(dynamicSamplingContext).length > 0) {
        return dynamicSamplingContext;
    } else {
        return undefined;
    }
}
/**
 * Turns a Dynamic Sampling Object into a baggage header by prefixing all the keys on the object with "sentry-".
 *
 * @param dynamicSamplingContext The Dynamic Sampling Context to turn into a header. For convenience and compatibility
 * with the `getDynamicSamplingContext` method on the Transaction class ,this argument can also be `undefined`. If it is
 * `undefined` the function will return `undefined`.
 * @returns a baggage header, created from `dynamicSamplingContext`, or `undefined` either if `dynamicSamplingContext`
 * was `undefined`, or if `dynamicSamplingContext` didn't contain any values.
 */ function dynamicSamplingContextToSentryBaggageHeader(// this also takes undefined for convenience and bundle size in other places
dynamicSamplingContext) {
    if (!dynamicSamplingContext) {
        return undefined;
    }
    // Prefix all DSC keys with "sentry-" and put them into a new object
    var sentryPrefixedDSC = Object.entries(dynamicSamplingContext).reduce(function(acc, param) {
        var _param = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(param, 2), dscKey = _param[0], dscValue = _param[1];
        if (dscValue) {
            acc["".concat(SENTRY_BAGGAGE_KEY_PREFIX).concat(dscKey)] = dscValue;
        }
        return acc;
    }, {});
    return objectToBaggageHeader(sentryPrefixedDSC);
}
/**
 * Will parse a baggage header, which is a simple key-value map, into a flat object.
 *
 * @param baggageHeader The baggage header to parse.
 * @returns a flat object containing all the key-value pairs from `baggageHeader`.
 */ function baggageHeaderToObject(baggageHeader) {
    return baggageHeader.split(",").map(function(baggageEntry) {
        return baggageEntry.split("=").map(function(keyOrValue) {
            return decodeURIComponent(keyOrValue.trim());
        });
    }).reduce(function(acc, param) {
        var _param = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(param, 2), key = _param[0], value = _param[1];
        acc[key] = value;
        return acc;
    }, {});
}
/**
 * Turns a flat object (key-value pairs) into a baggage header, which is also just key-value pairs.
 *
 * @param object The object to turn into a baggage header.
 * @returns a baggage header string, or `undefined` if the object didn't have any values, since an empty baggage header
 * is not spec compliant.
 */ function objectToBaggageHeader(object) {
    if (Object.keys(object).length === 0) {
        // An empty baggage header is not spec compliant: We return undefined.
        return undefined;
    }
    return Object.entries(object).reduce(function(baggageHeader, param, currentIndex) {
        var _param = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(param, 2), objectKey = _param[0], objectValue = _param[1];
        var baggageEntry = "".concat(encodeURIComponent(objectKey), "=").concat(encodeURIComponent(objectValue));
        var newBaggageHeader = currentIndex === 0 ? baggageEntry : "".concat(baggageHeader, ",").concat(baggageEntry);
        if (newBaggageHeader.length > MAX_BAGGAGE_STRING_LENGTH) {
            _debug_build_js__WEBPACK_IMPORTED_MODULE_2__/* .DEBUG_BUILD */ .X && _logger_js__WEBPACK_IMPORTED_MODULE_3__/* .logger.warn */ .kg.warn("Not adding key: ".concat(objectKey, " with val: ").concat(objectValue, " to baggage header due to exceeding baggage size limits."));
            return baggageHeader;
        } else {
            return newBaggageHeader;
        }
    }, "");
}
 //# sourceMappingURL=baggage.js.map


/***/ }),

/***/ 41413:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Rt": function() { return /* binding */ htmlTreeAsString; },
/* harmony export */   "iY": function() { return /* binding */ getComponentName; },
/* harmony export */   "l4": function() { return /* binding */ getLocationHref; },
/* harmony export */   "qT": function() { return /* binding */ getDomElement; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_instanceof_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(82670);
/* harmony import */ var _is_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(74020);
/* harmony import */ var _worldwide_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(74672);



// eslint-disable-next-line deprecation/deprecation
var WINDOW = (0,_worldwide_js__WEBPACK_IMPORTED_MODULE_0__/* .getGlobalObject */ .Rf)();
var DEFAULT_MAX_STRING_LENGTH = 80;
/**
 * Given a child DOM element, returns a query-selector statement describing that
 * and its ancestors
 * e.g. [HTMLElement] => body > div > input#foo.btn[name=baz]
 * @returns generated DOM path
 */ function htmlTreeAsString(elem) {
    var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    if (!elem) {
        return "<unknown>";
    }
    // try/catch both:
    // - accessing event.target (see getsentry/raven-js#838, #768)
    // - `htmlTreeAsString` because it's complex, and just accessing the DOM incorrectly
    // - can throw an exception in some circumstances.
    try {
        var currentElem = elem;
        var MAX_TRAVERSE_HEIGHT = 5;
        var out = [];
        var height = 0;
        var len = 0;
        var separator = " > ";
        var sepLength = separator.length;
        var nextStr;
        var keyAttrs = Array.isArray(options) ? options : options.keyAttrs;
        var maxStringLength = !Array.isArray(options) && options.maxStringLength || DEFAULT_MAX_STRING_LENGTH;
        while(currentElem && height++ < MAX_TRAVERSE_HEIGHT){
            nextStr = _htmlElementAsString(currentElem, keyAttrs);
            // bail out if
            // - nextStr is the 'html' element
            // - the length of the string that would be created exceeds maxStringLength
            //   (ignore this limit if we are on the first iteration)
            if (nextStr === "html" || height > 1 && len + out.length * sepLength + nextStr.length >= maxStringLength) {
                break;
            }
            out.push(nextStr);
            len += nextStr.length;
            currentElem = currentElem.parentNode;
        }
        return out.reverse().join(separator);
    } catch (_oO) {
        return "<unknown>";
    }
}
/**
 * Returns a simple, query-selector representation of a DOM element
 * e.g. [HTMLElement] => input#foo.btn[name=baz]
 * @returns generated DOM path
 */ function _htmlElementAsString(el, keyAttrs) {
    var elem = el;
    var out = [];
    var className;
    var classes;
    var key;
    var attr;
    var i;
    if (!elem || !elem.tagName) {
        return "";
    }
    // @ts-expect-error WINDOW has HTMLElement
    if (WINDOW.HTMLElement) {
        // If using the component name annotation plugin, this value may be available on the DOM node
        if ((0,_swc_helpers_src_instanceof_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(elem, HTMLElement) && elem.dataset && elem.dataset["sentryComponent"]) {
            return elem.dataset["sentryComponent"];
        }
    }
    out.push(elem.tagName.toLowerCase());
    // Pairs of attribute keys defined in `serializeAttribute` and their values on element.
    var keyAttrPairs = keyAttrs && keyAttrs.length ? keyAttrs.filter(function(keyAttr) {
        return elem.getAttribute(keyAttr);
    }).map(function(keyAttr) {
        return [
            keyAttr,
            elem.getAttribute(keyAttr)
        ];
    }) : null;
    if (keyAttrPairs && keyAttrPairs.length) {
        keyAttrPairs.forEach(function(keyAttrPair) {
            out.push("[".concat(keyAttrPair[0], '="').concat(keyAttrPair[1], '"]'));
        });
    } else {
        if (elem.id) {
            out.push("#".concat(elem.id));
        }
        // eslint-disable-next-line prefer-const
        className = elem.className;
        if (className && (0,_is_js__WEBPACK_IMPORTED_MODULE_2__/* .isString */ .HD)(className)) {
            classes = className.split(/\s+/);
            for(i = 0; i < classes.length; i++){
                out.push(".".concat(classes[i]));
            }
        }
    }
    var allowedAttrs = [
        "aria-label",
        "type",
        "name",
        "title",
        "alt"
    ];
    for(i = 0; i < allowedAttrs.length; i++){
        key = allowedAttrs[i];
        attr = elem.getAttribute(key);
        if (attr) {
            out.push("[".concat(key, '="').concat(attr, '"]'));
        }
    }
    return out.join("");
}
/**
 * A safe form of location.href
 */ function getLocationHref() {
    try {
        return WINDOW.document.location.href;
    } catch (oO) {
        return "";
    }
}
/**
 * Gets a DOM element by using document.querySelector.
 *
 * This wrapper will first check for the existance of the function before
 * actually calling it so that we don't have to take care of this check,
 * every time we want to access the DOM.
 *
 * Reason: DOM/querySelector is not available in all environments.
 *
 * We have to cast to any because utils can be consumed by a variety of environments,
 * and we don't want to break TS users. If you know what element will be selected by
 * `document.querySelector`, specify it as part of the generic call. For example,
 * `const element = getDomElement<Element>('selector');`
 *
 * @param selector the selector string passed on to document.querySelector
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function getDomElement(selector) {
    if (WINDOW.document && WINDOW.document.querySelector) {
        return WINDOW.document.querySelector(selector);
    }
    return null;
}
/**
 * Given a DOM element, traverses up the tree until it finds the first ancestor node
 * that has the `data-sentry-component` attribute. This attribute is added at build-time
 * by projects that have the component name annotation plugin installed.
 *
 * @returns a string representation of the component for the provided DOM element, or `null` if not found
 */ function getComponentName(elem) {
    // @ts-expect-error WINDOW has HTMLElement
    if (!WINDOW.HTMLElement) {
        return null;
    }
    var currentElem = elem;
    var MAX_TRAVERSE_HEIGHT = 5;
    for(var i = 0; i < MAX_TRAVERSE_HEIGHT; i++){
        if (!currentElem) {
            return null;
        }
        if ((0,_swc_helpers_src_instanceof_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(currentElem, HTMLElement) && currentElem.dataset["sentryComponent"]) {
            return currentElem.dataset["sentryComponent"];
        }
        currentElem = currentElem.parentNode;
    }
    return null;
}
 //# sourceMappingURL=browser.js.map


/***/ }),

/***/ 35614:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "X": function() { return /* binding */ DEBUG_BUILD; }
/* harmony export */ });
/**
 * This serves as a build time flag that will be true by default, but false in non-debug builds or if users replace `__SENTRY_DEBUG__` in their generated code.
 *
 * ATTENTION: This constant must never cross package boundaries (i.e. be exported) to guarantee that it can be used for tree shaking.
 */ var DEBUG_BUILD =  false || false;
 //# sourceMappingURL=debug-build.js.map


/***/ }),

/***/ 74020:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Cy": function() { return /* binding */ isSyntheticEvent; },
/* harmony export */   "HD": function() { return /* binding */ isString; },
/* harmony export */   "J8": function() { return /* binding */ isThenable; },
/* harmony export */   "Kj": function() { return /* binding */ isRegExp; },
/* harmony export */   "Le": function() { return /* binding */ isParameterizedString; },
/* harmony export */   "PO": function() { return /* binding */ isPlainObject; },
/* harmony export */   "TX": function() { return /* binding */ isDOMError; },
/* harmony export */   "V9": function() { return /* binding */ isInstanceOf; },
/* harmony export */   "VW": function() { return /* binding */ isErrorEvent; },
/* harmony export */   "VZ": function() { return /* binding */ isError; },
/* harmony export */   "cO": function() { return /* binding */ isEvent; },
/* harmony export */   "fm": function() { return /* binding */ isDOMException; },
/* harmony export */   "i2": function() { return /* binding */ isNaN; },
/* harmony export */   "kK": function() { return /* binding */ isElement; },
/* harmony export */   "pt": function() { return /* binding */ isPrimitive; },
/* harmony export */   "y1": function() { return /* binding */ isVueViewModel; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_instanceof_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(82670);
// eslint-disable-next-line @typescript-eslint/unbound-method

var objectToString = Object.prototype.toString;
/**
 * Checks whether given value's type is one of a few Error or Error-like
 * {@link isError}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function isError(wat) {
    switch(objectToString.call(wat)){
        case "[object Error]":
        case "[object Exception]":
        case "[object DOMException]":
            return true;
        default:
            return isInstanceOf(wat, Error);
    }
}
/**
 * Checks whether given value is an instance of the given built-in class.
 *
 * @param wat The value to be checked
 * @param className
 * @returns A boolean representing the result.
 */ function isBuiltin(wat, className) {
    return objectToString.call(wat) === "[object ".concat(className, "]");
}
/**
 * Checks whether given value's type is ErrorEvent
 * {@link isErrorEvent}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function isErrorEvent(wat) {
    return isBuiltin(wat, "ErrorEvent");
}
/**
 * Checks whether given value's type is DOMError
 * {@link isDOMError}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function isDOMError(wat) {
    return isBuiltin(wat, "DOMError");
}
/**
 * Checks whether given value's type is DOMException
 * {@link isDOMException}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function isDOMException(wat) {
    return isBuiltin(wat, "DOMException");
}
/**
 * Checks whether given value's type is a string
 * {@link isString}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function isString(wat) {
    return isBuiltin(wat, "String");
}
/**
 * Checks whether given string is parameterized
 * {@link isParameterizedString}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function isParameterizedString(wat) {
    return typeof wat === "object" && wat !== null && "__sentry_template_string__" in wat && "__sentry_template_values__" in wat;
}
/**
 * Checks whether given value is a primitive (undefined, null, number, boolean, string, bigint, symbol)
 * {@link isPrimitive}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function isPrimitive(wat) {
    return wat === null || isParameterizedString(wat) || typeof wat !== "object" && typeof wat !== "function";
}
/**
 * Checks whether given value's type is an object literal, or a class instance.
 * {@link isPlainObject}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function isPlainObject(wat) {
    return isBuiltin(wat, "Object");
}
/**
 * Checks whether given value's type is an Event instance
 * {@link isEvent}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function isEvent(wat) {
    return typeof Event !== "undefined" && isInstanceOf(wat, Event);
}
/**
 * Checks whether given value's type is an Element instance
 * {@link isElement}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function isElement(wat) {
    return typeof Element !== "undefined" && isInstanceOf(wat, Element);
}
/**
 * Checks whether given value's type is an regexp
 * {@link isRegExp}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function isRegExp(wat) {
    return isBuiltin(wat, "RegExp");
}
/**
 * Checks whether given value has a then function.
 * @param wat A value to be checked.
 */ function isThenable(wat) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    return Boolean(wat && wat.then && typeof wat.then === "function");
}
/**
 * Checks whether given value's type is a SyntheticEvent
 * {@link isSyntheticEvent}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function isSyntheticEvent(wat) {
    return isPlainObject(wat) && "nativeEvent" in wat && "preventDefault" in wat && "stopPropagation" in wat;
}
/**
 * Checks whether given value is NaN
 * {@link isNaN}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function isNaN(wat) {
    return typeof wat === "number" && wat !== wat;
}
/**
 * Checks whether given value's type is an instance of provided constructor.
 * {@link isInstanceOf}.
 *
 * @param wat A value to be checked.
 * @param base A constructor to be used in a check.
 * @returns A boolean representing the result.
 */ function isInstanceOf(wat, base) {
    try {
        return (0,_swc_helpers_src_instanceof_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(wat, base);
    } catch (_e) {
        return false;
    }
}
/**
 * Checks whether given value's type is a Vue ViewModel.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function isVueViewModel(wat) {
    // Not using Object.prototype.toString because in Vue 3 it would read the instance's Symbol(Symbol.toStringTag) property.
    return !!(typeof wat === "object" && wat !== null && (wat.__isVue || wat._isVue));
}
 //# sourceMappingURL=is.js.map


/***/ }),

/***/ 92957:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Cf": function() { return /* binding */ consoleSandbox; },
/* harmony export */   "LD": function() { return /* binding */ originalConsoleMethods; },
/* harmony export */   "RU": function() { return /* binding */ CONSOLE_LEVELS; },
/* harmony export */   "kg": function() { return /* binding */ logger; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(36305);
/* harmony import */ var _debug_build_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(35614);
/* harmony import */ var _worldwide_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(74672);



/** Prefix for logging strings */ var PREFIX = "Sentry Logger ";
var CONSOLE_LEVELS = [
    "debug",
    "info",
    "warn",
    "error",
    "log",
    "assert",
    "trace", 
];
/** This may be mutated by the console instrumentation. */ var originalConsoleMethods = {};
/** JSDoc */ /**
 * Temporarily disable sentry console instrumentations.
 *
 * @param callback The function to run against the original `console` messages
 * @returns The results of the callback
 */ function consoleSandbox(callback) {
    if (!("console" in _worldwide_js__WEBPACK_IMPORTED_MODULE_0__/* .GLOBAL_OBJ */ .n2)) {
        return callback();
    }
    var console = _worldwide_js__WEBPACK_IMPORTED_MODULE_0__/* .GLOBAL_OBJ.console */ .n2.console;
    var wrappedFuncs = {};
    var wrappedLevels = Object.keys(originalConsoleMethods);
    // Restore all wrapped console methods
    wrappedLevels.forEach(function(level) {
        var originalConsoleMethod = originalConsoleMethods[level];
        wrappedFuncs[level] = console[level];
        console[level] = originalConsoleMethod;
    });
    try {
        return callback();
    } finally{
        // Revert restoration to wrapped state
        wrappedLevels.forEach(function(level) {
            console[level] = wrappedFuncs[level];
        });
    }
}
function makeLogger() {
    var enabled = false;
    var logger = {
        enable: function() {
            enabled = true;
        },
        disable: function() {
            enabled = false;
        },
        isEnabled: function() {
            return enabled;
        }
    };
    if (_debug_build_js__WEBPACK_IMPORTED_MODULE_1__/* .DEBUG_BUILD */ .X) {
        CONSOLE_LEVELS.forEach(function(name) {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            logger[name] = function() {
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                    args[_key] = arguments[_key];
                }
                if (enabled) {
                    consoleSandbox(function() {
                        var _console;
                        (_console = _worldwide_js__WEBPACK_IMPORTED_MODULE_0__/* .GLOBAL_OBJ.console */ .n2.console)[name].apply(_console, [
                            "".concat(PREFIX, "[").concat(name, "]:")
                        ].concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(args)));
                    });
                }
            };
        });
    } else {
        CONSOLE_LEVELS.forEach(function(name) {
            logger[name] = function() {
                return undefined;
            };
        });
    }
    return logger;
}
var logger = makeLogger();
 //# sourceMappingURL=logger.js.map


/***/ }),

/***/ 11591:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "DM": function() { return /* binding */ uuid4; },
/* harmony export */   "Db": function() { return /* binding */ addExceptionTypeValue; },
/* harmony export */   "EG": function() { return /* binding */ addExceptionMechanism; },
/* harmony export */   "YO": function() { return /* binding */ checkOrSetAlreadyCaught; },
/* harmony export */   "go": function() { return /* binding */ addContextToFrame; },
/* harmony export */   "jH": function() { return /* binding */ getEventDescription; },
/* harmony export */   "lE": function() { return /* binding */ arrayify; }
/* harmony export */ });
/* unused harmony export parseSemver */
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(26042);
/* harmony import */ var _object_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(27389);
/* harmony import */ var _string_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(68813);
/* harmony import */ var _worldwide_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(74672);




/**
 * UUID4 generator
 *
 * @returns string Generated UUID4.
 */ function uuid4() {
    var gbl = _worldwide_js__WEBPACK_IMPORTED_MODULE_0__/* .GLOBAL_OBJ */ .n2;
    var crypto = gbl.crypto || gbl.msCrypto;
    var getRandomByte = function() {
        return Math.random() * 16;
    };
    try {
        if (crypto && crypto.randomUUID) {
            return crypto.randomUUID().replace(/-/g, "");
        }
        if (crypto && crypto.getRandomValues) {
            getRandomByte = function() {
                // crypto.getRandomValues might return undefined instead of the typed array
                // in old Chromium versions (e.g. 23.0.1235.0 (151422))
                // However, `typedArray` is still filled in-place.
                // @see https://developer.mozilla.org/en-US/docs/Web/API/Crypto/getRandomValues#typedarray
                var typedArray = new Uint8Array(1);
                crypto.getRandomValues(typedArray);
                return typedArray[0];
            };
        }
    } catch (_) {
    // some runtimes can crash invoking crypto
    // https://github.com/getsentry/sentry-javascript/issues/8935
    }
    // http://stackoverflow.com/questions/105034/how-to-create-a-guid-uuid-in-javascript/2117523#2117523
    // Concatenating the following numbers as strings results in '10000000100040008000100000000000'
    return ([
        1e7
    ] + 1e3 + 4e3 + 8e3 + 1e11).replace(/[018]/g, function(c) {
        return(// eslint-disable-next-line no-bitwise
        (c ^ (getRandomByte() & 15) >> c / 4).toString(16));
    });
}
function getFirstException(event) {
    return event.exception && event.exception.values ? event.exception.values[0] : undefined;
}
/**
 * Extracts either message or type+value from an event that can be used for user-facing logs
 * @returns event's description
 */ function getEventDescription(event) {
    var message = event.message, eventId = event.event_id;
    if (message) {
        return message;
    }
    var firstException = getFirstException(event);
    if (firstException) {
        if (firstException.type && firstException.value) {
            return "".concat(firstException.type, ": ").concat(firstException.value);
        }
        return firstException.type || firstException.value || eventId || "<unknown>";
    }
    return eventId || "<unknown>";
}
/**
 * Adds exception values, type and value to an synthetic Exception.
 * @param event The event to modify.
 * @param value Value of the exception.
 * @param type Type of the exception.
 * @hidden
 */ function addExceptionTypeValue(event, value, type) {
    var exception = event.exception = event.exception || {};
    var values = exception.values = exception.values || [];
    var firstException = values[0] = values[0] || {};
    if (!firstException.value) {
        firstException.value = value || "";
    }
    if (!firstException.type) {
        firstException.type = type || "Error";
    }
}
/**
 * Adds exception mechanism data to a given event. Uses defaults if the second parameter is not passed.
 *
 * @param event The event to modify.
 * @param newMechanism Mechanism data to add to the event.
 * @hidden
 */ function addExceptionMechanism(event, newMechanism) {
    var firstException = getFirstException(event);
    if (!firstException) {
        return;
    }
    var defaultMechanism = {
        type: "generic",
        handled: true
    };
    var currentMechanism = firstException.mechanism;
    firstException.mechanism = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, defaultMechanism, currentMechanism, newMechanism);
    if (newMechanism && "data" in newMechanism) {
        var mergedData = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, currentMechanism && currentMechanism.data, newMechanism.data);
        firstException.mechanism.data = mergedData;
    }
}
// https://semver.org/#is-there-a-suggested-regular-expression-regex-to-check-a-semver-string
var SEMVER_REGEXP = /^(0|[1-9]\d*)\.(0|[1-9]\d*)\.(0|[1-9]\d*)(?:-((?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*)(?:\.(?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*))*))?(?:\+([0-9a-zA-Z-]+(?:\.[0-9a-zA-Z-]+)*))?$/;
/**
 * Represents Semantic Versioning object
 */ /**
 * Parses input into a SemVer interface
 * @param input string representation of a semver version
 */ function parseSemver(input) {
    var match = input.match(SEMVER_REGEXP) || [];
    var major = parseInt(match[1], 10);
    var minor = parseInt(match[2], 10);
    var patch = parseInt(match[3], 10);
    return {
        buildmetadata: match[5],
        major: isNaN(major) ? undefined : major,
        minor: isNaN(minor) ? undefined : minor,
        patch: isNaN(patch) ? undefined : patch,
        prerelease: match[4]
    };
}
/**
 * This function adds context (pre/post/line) lines to the provided frame
 *
 * @param lines string[] containing all lines
 * @param frame StackFrame that will be mutated
 * @param linesOfContext number of context lines we want to add pre/post
 */ function addContextToFrame(lines, frame) {
    var linesOfContext = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 5;
    // When there is no line number in the frame, attaching context is nonsensical and will even break grouping
    if (frame.lineno === undefined) {
        return;
    }
    var maxLines = lines.length;
    var sourceLine = Math.max(Math.min(maxLines - 1, frame.lineno - 1), 0);
    frame.pre_context = lines.slice(Math.max(0, sourceLine - linesOfContext), sourceLine).map(function(line) {
        return (0,_string_js__WEBPACK_IMPORTED_MODULE_2__/* .snipLine */ .JM)(line, 0);
    });
    frame.context_line = (0,_string_js__WEBPACK_IMPORTED_MODULE_2__/* .snipLine */ .JM)(lines[Math.min(maxLines - 1, sourceLine)], frame.colno || 0);
    frame.post_context = lines.slice(Math.min(sourceLine + 1, maxLines), sourceLine + 1 + linesOfContext).map(function(line) {
        return (0,_string_js__WEBPACK_IMPORTED_MODULE_2__/* .snipLine */ .JM)(line, 0);
    });
}
/**
 * Checks whether or not we've already captured the given exception (note: not an identical exception - the very object
 * in question), and marks it captured if not.
 *
 * This is useful because it's possible for an error to get captured by more than one mechanism. After we intercept and
 * record an error, we rethrow it (assuming we've intercepted it before it's reached the top-level global handlers), so
 * that we don't interfere with whatever effects the error might have had were the SDK not there. At that point, because
 * the error has been rethrown, it's possible for it to bubble up to some other code we've instrumented. If it's not
 * caught after that, it will bubble all the way up to the global handlers (which of course we also instrument). This
 * function helps us ensure that even if we encounter the same error more than once, we only record it the first time we
 * see it.
 *
 * Note: It will ignore primitives (always return `false` and not mark them as seen), as properties can't be set on
 * them. {@link: Object.objectify} can be used on exceptions to convert any that are primitives into their equivalent
 * object wrapper forms so that this check will always work. However, because we need to flag the exact object which
 * will get rethrown, and because that rethrowing happens outside of the event processing pipeline, the objectification
 * must be done before the exception captured.
 *
 * @param A thrown exception to check or flag as having been seen
 * @returns `true` if the exception has already been captured, `false` if not (with the side effect of marking it seen)
 */ function checkOrSetAlreadyCaught(exception) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    if (exception && exception.__sentry_captured__) {
        return true;
    }
    try {
        // set it this way rather than by assignment so that it's not ennumerable and therefore isn't recorded by the
        // `ExtraErrorData` integration
        (0,_object_js__WEBPACK_IMPORTED_MODULE_3__/* .addNonEnumerableProperty */ .xp)(exception, "__sentry_captured__", true);
    } catch (err) {
    // `exception` is a primitive, so we can't mark it seen
    }
    return false;
}
/**
 * Checks whether the given input is already an array, and if it isn't, wraps it in one.
 *
 * @param maybeArray Input to turn into an array, if necessary
 * @returns The input, if already an array, or an array with the input as the only element, if not
 */ function arrayify(maybeArray) {
    return Array.isArray(maybeArray) ? maybeArray : [
        maybeArray
    ];
}
 //# sourceMappingURL=misc.js.map


/***/ }),

/***/ 92276:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Fv": function() { return /* binding */ normalize; },
  "Qy": function() { return /* binding */ normalizeToSize; }
});

// UNUSED EXPORTS: normalizeUrlToBase, walk

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs
var _sliced_to_array = __webpack_require__(10253);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_type_of.mjs
var _type_of = __webpack_require__(82222);
// EXTERNAL MODULE: ./node_modules/@sentry/utils/esm/is.js
var is = __webpack_require__(74020);
;// CONCATENATED MODULE: ./node_modules/@sentry/utils/esm/memo.js
/* eslint-disable @typescript-eslint/no-unsafe-member-access */ /* eslint-disable @typescript-eslint/no-explicit-any */ /**
 * Helper to decycle json objects
 */ function memoBuilder() {
    var memoize = function memoize(obj) {
        if (hasWeakSet) {
            if (inner.has(obj)) {
                return true;
            }
            inner.add(obj);
            return false;
        }
        // eslint-disable-next-line @typescript-eslint/prefer-for-of
        for(var i = 0; i < inner.length; i++){
            var value = inner[i];
            if (value === obj) {
                return true;
            }
        }
        inner.push(obj);
        return false;
    };
    var unmemoize = function unmemoize(obj) {
        if (hasWeakSet) {
            inner.delete(obj);
        } else {
            for(var i = 0; i < inner.length; i++){
                if (inner[i] === obj) {
                    inner.splice(i, 1);
                    break;
                }
            }
        }
    };
    var hasWeakSet = typeof WeakSet === "function";
    var inner = hasWeakSet ? new WeakSet() : [];
    return [
        memoize,
        unmemoize
    ];
}
 //# sourceMappingURL=memo.js.map

// EXTERNAL MODULE: ./node_modules/@sentry/utils/esm/object.js
var object = __webpack_require__(27389);
// EXTERNAL MODULE: ./node_modules/@sentry/utils/esm/stacktrace.js
var stacktrace = __webpack_require__(91987);
;// CONCATENATED MODULE: ./node_modules/@sentry/utils/esm/normalize.js






/**
 * Recursively normalizes the given object.
 *
 * - Creates a copy to prevent original input mutation
 * - Skips non-enumerable properties
 * - When stringifying, calls `toJSON` if implemented
 * - Removes circular references
 * - Translates non-serializable values (`undefined`/`NaN`/functions) to serializable format
 * - Translates known global objects/classes to a string representations
 * - Takes care of `Error` object serialization
 * - Optionally limits depth of final output
 * - Optionally limits number of properties/elements included in any single object/array
 *
 * @param input The object to be normalized.
 * @param depth The max depth to which to normalize the object. (Anything deeper stringified whole.)
 * @param maxProperties The max number of elements or properties to be included in any single array or
 * object in the normallized output.
 * @returns A normalized version of the object, or `"**non-serializable**"` if any errors are thrown during normalization.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function normalize(input) {
    var depth = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 100, maxProperties = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : +Infinity;
    try {
        // since we're at the outermost level, we don't provide a key
        return visit("", input, depth, maxProperties);
    } catch (err) {
        return {
            ERROR: "**non-serializable** (".concat(err, ")")
        };
    }
}
/** JSDoc */ function normalizeToSize(// eslint-disable-next-line @typescript-eslint/no-explicit-any
object) {
    var // Default Node.js REPL depth
    depth = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 3, // 100kB, as 200kB is max payload size, so half sounds reasonable
    maxSize = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 100 * 1024;
    var normalized = normalize(object, depth);
    if (jsonSize(normalized) > maxSize) {
        return normalizeToSize(object, depth - 1, maxSize);
    }
    return normalized;
}
/**
 * Visits a node to perform normalization on it
 *
 * @param key The key corresponding to the given node
 * @param value The node to be visited
 * @param depth Optional number indicating the maximum recursion depth
 * @param maxProperties Optional maximum number of properties/elements included in any single object/array
 * @param memo Optional Memo class handling decycling
 */ function visit(key, value) {
    var depth = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : +Infinity, maxProperties = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : +Infinity, memo = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : memoBuilder();
    var _memo = (0,_sliced_to_array/* default */.Z)(memo, 2), memoize = _memo[0], unmemoize = _memo[1];
    // Get the simple cases out of the way first
    if (value == null || // this matches null and undefined -> eqeq not eqeqeq
    [
        "number",
        "boolean",
        "string"
    ].includes(typeof value === "undefined" ? "undefined" : (0,_type_of/* default */.Z)(value)) && !(0,is/* isNaN */.i2)(value)) {
        return value;
    }
    var stringified = stringifyValue(key, value);
    // Anything we could potentially dig into more (objects or arrays) will have come back as `"[object XXXX]"`.
    // Everything else will have already been serialized, so if we don't see that pattern, we're done.
    if (!stringified.startsWith("[object ")) {
        return stringified;
    }
    // From here on, we can assert that `value` is either an object or an array.
    // Do not normalize objects that we know have already been normalized. As a general rule, the
    // "__sentry_skip_normalization__" property should only be used sparingly and only should only be set on objects that
    // have already been normalized.
    if (value["__sentry_skip_normalization__"]) {
        return value;
    }
    // We can set `__sentry_override_normalization_depth__` on an object to ensure that from there
    // We keep a certain amount of depth.
    // This should be used sparingly, e.g. we use it for the redux integration to ensure we get a certain amount of state.
    var remainingDepth = typeof value["__sentry_override_normalization_depth__"] === "number" ? value["__sentry_override_normalization_depth__"] : depth;
    // We're also done if we've reached the max depth
    if (remainingDepth === 0) {
        // At this point we know `serialized` is a string of the form `"[object XXXX]"`. Clean it up so it's just `"[XXXX]"`.
        return stringified.replace("object ", "");
    }
    // If we've already visited this branch, bail out, as it's circular reference. If not, note that we're seeing it now.
    if (memoize(value)) {
        return "[Circular ~]";
    }
    // If the value has a `toJSON` method, we call it to extract more information
    var valueWithToJSON = value;
    if (valueWithToJSON && typeof valueWithToJSON.toJSON === "function") {
        try {
            var jsonValue = valueWithToJSON.toJSON();
            // We need to normalize the return value of `.toJSON()` in case it has circular references
            return visit("", jsonValue, remainingDepth - 1, maxProperties, memo);
        } catch (err) {
        // pass (The built-in `toJSON` failed, but we can still try to do it ourselves)
        }
    }
    // At this point we know we either have an object or an array, we haven't seen it before, and we're going to recurse
    // because we haven't yet reached the max depth. Create an accumulator to hold the results of visiting each
    // property/entry, and keep track of the number of items we add to it.
    var normalized = Array.isArray(value) ? [] : {};
    var numAdded = 0;
    // Before we begin, convert`Error` and`Event` instances into plain objects, since some of each of their relevant
    // properties are non-enumerable and otherwise would get missed.
    var visitable = (0,object/* convertToPlainObject */.Sh)(value);
    for(var visitKey in visitable){
        // Avoid iterating over fields in the prototype if they've somehow been exposed to enumeration.
        if (!Object.prototype.hasOwnProperty.call(visitable, visitKey)) {
            continue;
        }
        if (numAdded >= maxProperties) {
            normalized[visitKey] = "[MaxProperties ~]";
            break;
        }
        // Recursively visit all the child nodes
        var visitValue = visitable[visitKey];
        normalized[visitKey] = visit(visitKey, visitValue, remainingDepth - 1, maxProperties, memo);
        numAdded++;
    }
    // Once we've visited all the branches, remove the parent from memo storage
    unmemoize(value);
    // Return accumulated values
    return normalized;
}
/* eslint-disable complexity */ /**
 * Stringify the given value. Handles various known special values and types.
 *
 * Not meant to be used on simple primitives which already have a string representation, as it will, for example, turn
 * the number 1231 into "[Object Number]", nor on `null`, as it will throw.
 *
 * @param value The value to stringify
 * @returns A stringified representation of the given value
 */ function stringifyValue(key, // this type is a tiny bit of a cheat, since this function does handle NaN (which is technically a number), but for
// our internal use, it'll do
value) {
    try {
        if (key === "domain" && value && typeof value === "object" && value._events) {
            return "[Domain]";
        }
        if (key === "domainEmitter") {
            return "[DomainEmitter]";
        }
        // It's safe to use `global`, `window`, and `document` here in this manner, as we are asserting using `typeof` first
        // which won't throw if they are not present.
        if (typeof __webpack_require__.g !== "undefined" && value === __webpack_require__.g) {
            return "[Global]";
        }
        // eslint-disable-next-line no-restricted-globals
        if ( true && value === window) {
            return "[Window]";
        }
        // eslint-disable-next-line no-restricted-globals
        if (typeof document !== "undefined" && value === document) {
            return "[Document]";
        }
        if ((0,is/* isVueViewModel */.y1)(value)) {
            return "[VueViewModel]";
        }
        // React's SyntheticEvent thingy
        if ((0,is/* isSyntheticEvent */.Cy)(value)) {
            return "[SyntheticEvent]";
        }
        if (typeof value === "number" && value !== value) {
            return "[NaN]";
        }
        if (typeof value === "function") {
            return "[Function: ".concat((0,stacktrace/* getFunctionName */.$P)(value), "]");
        }
        if ((typeof value === "undefined" ? "undefined" : (0,_type_of/* default */.Z)(value)) === "symbol") {
            return "[".concat(String(value), "]");
        }
        // stringified BigInts are indistinguishable from regular numbers, so we need to label them to avoid confusion
        if ((typeof value === "undefined" ? "undefined" : (0,_type_of/* default */.Z)(value)) === "bigint") {
            return "[BigInt: ".concat(String(value), "]");
        }
        // Now that we've knocked out all the special cases and the primitives, all we have left are objects. Simply casting
        // them to strings means that instances of classes which haven't defined their `toStringTag` will just come out as
        // `"[object Object]"`. If we instead look at the constructor's name (which is the same as the name of the class),
        // we can make sure that only plain objects come out that way.
        var objName = getConstructorName(value);
        // Handle HTML Elements
        if (/^HTML(\w*)Element$/.test(objName)) {
            return "[HTMLElement: ".concat(objName, "]");
        }
        return "[object ".concat(objName, "]");
    } catch (err) {
        return "**non-serializable** (".concat(err, ")");
    }
}
/* eslint-enable complexity */ function getConstructorName(value) {
    var prototype = Object.getPrototypeOf(value);
    return prototype ? prototype.constructor.name : "null prototype";
}
/** Calculates bytes size of input string */ function utf8Length(value) {
    // eslint-disable-next-line no-bitwise
    return ~-encodeURI(value).split(/%..|./).length;
}
/** Calculates bytes size of input object */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function jsonSize(value) {
    return utf8Length(JSON.stringify(value));
}
/**
 * Normalizes URLs in exceptions and stacktraces to a base path so Sentry can fingerprint
 * across platforms and working directory.
 *
 * @param url The URL to be normalized.
 * @param basePath The application base path.
 * @returns The normalized URL.
 */ function normalizeUrlToBase(url, basePath) {
    var escapedBase = basePath// Backslash to forward
    .replace(/\\/g, "/")// Escape RegExp special characters
    .replace(/[|\\{}()[\]^$+*?.]/g, "\\$&");
    var newUrl = url;
    try {
        newUrl = decodeURI(url);
    } catch (_Oo) {
    // Sometime this breaks
    }
    return newUrl.replace(/\\/g, "/").replace(/webpack:\/?/g, "") // Remove intermediate base path
    // eslint-disable-next-line @sentry-internal/sdk/no-regexp-constructor
    .replace(new RegExp("(file://)?/*".concat(escapedBase, "/*"), "ig"), "app:///");
}
 //# sourceMappingURL=normalize.js.map


/***/ }),

/***/ 27389:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$Q": function() { return /* binding */ markFunctionWrapped; },
/* harmony export */   "HK": function() { return /* binding */ getOriginalFunction; },
/* harmony export */   "Jr": function() { return /* binding */ dropUndefinedKeys; },
/* harmony export */   "Sh": function() { return /* binding */ convertToPlainObject; },
/* harmony export */   "_j": function() { return /* binding */ urlEncode; },
/* harmony export */   "hl": function() { return /* binding */ fill; },
/* harmony export */   "xp": function() { return /* binding */ addNonEnumerableProperty; },
/* harmony export */   "zf": function() { return /* binding */ extractExceptionKeysForMessage; }
/* harmony export */ });
/* unused harmony export objectify */
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26042);
/* harmony import */ var _browser_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(41413);
/* harmony import */ var _debug_build_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(35614);
/* harmony import */ var _is_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(74020);
/* harmony import */ var _logger_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(92957);
/* harmony import */ var _string_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(68813);







/**
 * Replace a method in an object with a wrapped version of itself.
 *
 * @param source An object that contains a method to be wrapped.
 * @param name The name of the method to be wrapped.
 * @param replacementFactory A higher-order function that takes the original version of the given method and returns a
 * wrapped version. Note: The function returned by `replacementFactory` needs to be a non-arrow function, in order to
 * preserve the correct value of `this`, and the original method must be called using `origMethod.call(this, <other
 * args>)` or `origMethod.apply(this, [<other args>])` (rather than being called directly), again to preserve `this`.
 * @returns void
 */ function fill(source, name, replacementFactory) {
    if (!(name in source)) {
        return;
    }
    var original = source[name];
    var wrapped = replacementFactory(original);
    // Make sure it's a function first, as we need to attach an empty prototype for `defineProperties` to work
    // otherwise it'll throw "TypeError: Object.defineProperties called on non-object"
    if (typeof wrapped === "function") {
        markFunctionWrapped(wrapped, original);
    }
    source[name] = wrapped;
}
/**
 * Defines a non-enumerable property on the given object.
 *
 * @param obj The object on which to set the property
 * @param name The name of the property to be set
 * @param value The value to which to set the property
 */ function addNonEnumerableProperty(obj, name, value) {
    try {
        Object.defineProperty(obj, name, {
            // enumerable: false, // the default, so we can save on bundle size by not explicitly setting it
            value: value,
            writable: true,
            configurable: true
        });
    } catch (o_O) {
        _debug_build_js__WEBPACK_IMPORTED_MODULE_0__/* .DEBUG_BUILD */ .X && _logger_js__WEBPACK_IMPORTED_MODULE_1__/* .logger.log */ .kg.log('Failed to add non-enumerable property "'.concat(name, '" to object'), obj);
    }
}
/**
 * Remembers the original function on the wrapped function and
 * patches up the prototype.
 *
 * @param wrapped the wrapper function
 * @param original the original function that gets wrapped
 */ function markFunctionWrapped(wrapped, original) {
    try {
        var proto = original.prototype || {};
        wrapped.prototype = original.prototype = proto;
        addNonEnumerableProperty(wrapped, "__sentry_original__", original);
    } catch (o_O) {} // eslint-disable-line no-empty
}
/**
 * This extracts the original function if available.  See
 * `markFunctionWrapped` for more information.
 *
 * @param func the function to unwrap
 * @returns the unwrapped version of the function if available.
 */ function getOriginalFunction(func) {
    return func.__sentry_original__;
}
/**
 * Encodes given object into url-friendly format
 *
 * @param object An object that contains serializable values
 * @returns string Encoded
 */ function urlEncode(object) {
    return Object.keys(object).map(function(key) {
        return "".concat(encodeURIComponent(key), "=").concat(encodeURIComponent(object[key]));
    }).join("&");
}
/**
 * Transforms any `Error` or `Event` into a plain object with all of their enumerable properties, and some of their
 * non-enumerable properties attached.
 *
 * @param value Initial source that we have to transform in order for it to be usable by the serializer
 * @returns An Event or Error turned into an object - or the value argurment itself, when value is neither an Event nor
 *  an Error.
 */ function convertToPlainObject(value) {
    if ((0,_is_js__WEBPACK_IMPORTED_MODULE_2__/* .isError */ .VZ)(value)) {
        return (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
            message: value.message,
            name: value.name,
            stack: value.stack
        }, getOwnProperties(value));
    } else if ((0,_is_js__WEBPACK_IMPORTED_MODULE_2__/* .isEvent */ .cO)(value)) {
        var newObj = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
            type: value.type,
            target: serializeEventTarget(value.target),
            currentTarget: serializeEventTarget(value.currentTarget)
        }, getOwnProperties(value));
        if (typeof CustomEvent !== "undefined" && (0,_is_js__WEBPACK_IMPORTED_MODULE_2__/* .isInstanceOf */ .V9)(value, CustomEvent)) {
            newObj.detail = value.detail;
        }
        return newObj;
    } else {
        return value;
    }
}
/** Creates a string representation of the target of an `Event` object */ function serializeEventTarget(target) {
    try {
        return (0,_is_js__WEBPACK_IMPORTED_MODULE_2__/* .isElement */ .kK)(target) ? (0,_browser_js__WEBPACK_IMPORTED_MODULE_4__/* .htmlTreeAsString */ .Rt)(target) : Object.prototype.toString.call(target);
    } catch (_oO) {
        return "<unknown>";
    }
}
/** Filters out all but an object's own properties */ function getOwnProperties(obj) {
    if (typeof obj === "object" && obj !== null) {
        var extractedProps = {};
        for(var property in obj){
            if (Object.prototype.hasOwnProperty.call(obj, property)) {
                extractedProps[property] = obj[property];
            }
        }
        return extractedProps;
    } else {
        return {};
    }
}
/**
 * Given any captured exception, extract its keys and create a sorted
 * and truncated list that will be used inside the event message.
 * eg. `Non-error exception captured with keys: foo, bar, baz`
 */ function extractExceptionKeysForMessage(exception) {
    var maxLength = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 40;
    var keys = Object.keys(convertToPlainObject(exception));
    keys.sort();
    if (!keys.length) {
        return "[object has no keys]";
    }
    if (keys[0].length >= maxLength) {
        return (0,_string_js__WEBPACK_IMPORTED_MODULE_5__/* .truncate */ .$G)(keys[0], maxLength);
    }
    for(var includedKeys = keys.length; includedKeys > 0; includedKeys--){
        var serialized = keys.slice(0, includedKeys).join(", ");
        if (serialized.length > maxLength) {
            continue;
        }
        if (includedKeys === keys.length) {
            return serialized;
        }
        return (0,_string_js__WEBPACK_IMPORTED_MODULE_5__/* .truncate */ .$G)(serialized, maxLength);
    }
    return "";
}
/**
 * Given any object, return a new object having removed all fields whose value was `undefined`.
 * Works recursively on objects and arrays.
 *
 * Attention: This function keeps circular references in the returned object.
 */ function dropUndefinedKeys(inputValue) {
    // This map keeps track of what already visited nodes map to.
    // Our Set - based memoBuilder doesn't work here because we want to the output object to have the same circular
    // references as the input object.
    var memoizationMap = new Map();
    // This function just proxies `_dropUndefinedKeys` to keep the `memoBuilder` out of this function's API
    return _dropUndefinedKeys(inputValue, memoizationMap);
}
function _dropUndefinedKeys(inputValue, memoizationMap) {
    if (isPojo(inputValue)) {
        // If this node has already been visited due to a circular reference, return the object it was mapped to in the new object
        var memoVal = memoizationMap.get(inputValue);
        if (memoVal !== undefined) {
            return memoVal;
        }
        var returnValue = {};
        // Store the mapping of this value in case we visit it again, in case of circular data
        memoizationMap.set(inputValue, returnValue);
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = Object.keys(inputValue)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var key = _step.value;
                if (typeof inputValue[key] !== "undefined") {
                    returnValue[key] = _dropUndefinedKeys(inputValue[key], memoizationMap);
                }
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return returnValue;
    }
    if (Array.isArray(inputValue)) {
        // If this node has already been visited due to a circular reference, return the array it was mapped to in the new object
        var memoVal1 = memoizationMap.get(inputValue);
        if (memoVal1 !== undefined) {
            return memoVal1;
        }
        var returnValue1 = [];
        // Store the mapping of this value in case we visit it again, in case of circular data
        memoizationMap.set(inputValue, returnValue1);
        inputValue.forEach(function(item) {
            returnValue1.push(_dropUndefinedKeys(item, memoizationMap));
        });
        return returnValue1;
    }
    return inputValue;
}
function isPojo(input) {
    if (!(0,_is_js__WEBPACK_IMPORTED_MODULE_2__/* .isPlainObject */ .PO)(input)) {
        return false;
    }
    try {
        var name = Object.getPrototypeOf(input).constructor.name;
        return !name || name === "Object";
    } catch (e) {
        return true;
    }
}
/**
 * Ensure that something is an object.
 *
 * Turns `undefined` and `null` into `String`s and all other primitives into instances of their respective wrapper
 * classes (String, Boolean, Number, etc.). Acts as the identity function on non-primitives.
 *
 * @param wat The subject of the objectification
 * @returns A version of `wat` which can safely be used with `Object` class methods
 */ function objectify(wat) {
    var objectified;
    switch(true){
        case wat === undefined || wat === null:
            objectified = new String(wat);
            break;
        // Though symbols and bigints do have wrapper classes (`Symbol` and `BigInt`, respectively), for whatever reason
        // those classes don't have constructors which can be used with the `new` keyword. We therefore need to cast each as
        // an object in order to wrap it.
        case (typeof wat === "undefined" ? "undefined" : _type_of(wat)) === "symbol" || (typeof wat === "undefined" ? "undefined" : _type_of(wat)) === "bigint":
            objectified = Object(wat);
            break;
        // this will catch the remaining primitives: `String`, `Number`, and `Boolean`
        case isPrimitive(wat):
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            objectified = new wat.constructor(wat);
            break;
        // by process of elimination, at this point we know that `wat` must already be an object
        default:
            objectified = wat;
            break;
    }
    return objectified;
}
 //# sourceMappingURL=object.js.map


/***/ }),

/***/ 91987:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$P": function() { return /* binding */ getFunctionName; },
/* harmony export */   "Sq": function() { return /* binding */ stackParserFromStackParserOptions; },
/* harmony export */   "pE": function() { return /* binding */ createStackParser; }
/* harmony export */ });
/* unused harmony exports nodeStackLineParser, stripSentryFramesAndReverse */
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(36305);





var STACKTRACE_FRAME_LIMIT = 50;
// Used to sanitize webpack (error: *) wrapped stack errors
var WEBPACK_ERROR_REGEXP = /\(error: (.*)\)/;
var STRIP_FRAME_REGEXP = /captureMessage|captureException/;
/**
 * Creates a stack parser with the supplied line parsers
 *
 * StackFrames are returned in the correct order for Sentry Exception
 * frames and with Sentry SDK internal frames removed from the top and bottom
 *
 */ function createStackParser() {
    for(var _len = arguments.length, parsers = new Array(_len), _key = 0; _key < _len; _key++){
        parsers[_key] = arguments[_key];
    }
    var sortedParsers = parsers.sort(function(a, b) {
        return a[0] - b[0];
    }).map(function(p) {
        return p[1];
    });
    return function(stack) {
        var skipFirst = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
        var frames = [];
        var lines = stack.split("\n");
        for(var i = skipFirst; i < lines.length; i++){
            var line = lines[i];
            // Ignore lines over 1kb as they are unlikely to be stack frames.
            // Many of the regular expressions use backtracking which results in run time that increases exponentially with
            // input size. Huge strings can result in hangs/Denial of Service:
            // https://github.com/getsentry/sentry-javascript/issues/2286
            if (line.length > 1024) {
                continue;
            }
            // https://github.com/getsentry/sentry-javascript/issues/5459
            // Remove webpack (error: *) wrappers
            var cleanedLine = WEBPACK_ERROR_REGEXP.test(line) ? line.replace(WEBPACK_ERROR_REGEXP, "$1") : line;
            // https://github.com/getsentry/sentry-javascript/issues/7813
            // Skip Error: lines
            if (cleanedLine.match(/\S*Error: /)) {
                continue;
            }
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = sortedParsers[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var parser = _step.value;
                    var frame = parser(cleanedLine);
                    if (frame) {
                        frames.push(frame);
                        break;
                    }
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
            if (frames.length >= STACKTRACE_FRAME_LIMIT) {
                break;
            }
        }
        return stripSentryFramesAndReverse(frames);
    };
}
/**
 * Gets a stack parser implementation from Options.stackParser
 * @see Options
 *
 * If options contains an array of line parsers, it is converted into a parser
 */ function stackParserFromStackParserOptions(stackParser) {
    if (Array.isArray(stackParser)) {
        return createStackParser.apply(void 0, (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(stackParser));
    }
    return stackParser;
}
/**
 * Removes Sentry frames from the top and bottom of the stack if present and enforces a limit of max number of frames.
 * Assumes stack input is ordered from top to bottom and returns the reverse representation so call site of the
 * function that caused the crash is the last frame in the array.
 * @hidden
 */ function stripSentryFramesAndReverse(stack) {
    if (!stack.length) {
        return [];
    }
    var localStack = Array.from(stack);
    // If stack starts with one of our API calls, remove it (starts, meaning it's the top of the stack - aka last call)
    if (/sentryWrapped/.test(localStack[localStack.length - 1].function || "")) {
        localStack.pop();
    }
    // Reversing in the middle of the procedure allows us to just pop the values off the stack
    localStack.reverse();
    // If stack ends with one of our internal API calls, remove it (ends, meaning it's the bottom of the stack - aka top-most call)
    if (STRIP_FRAME_REGEXP.test(localStack[localStack.length - 1].function || "")) {
        localStack.pop();
        // When using synthetic events, we will have a 2 levels deep stack, as `new Error('Sentry syntheticException')`
        // is produced within the hub itself, making it:
        //
        //   Sentry.captureException()
        //   getCurrentHub().captureException()
        //
        // instead of just the top `Sentry` call itself.
        // This forces us to possibly strip an additional frame in the exact same was as above.
        if (STRIP_FRAME_REGEXP.test(localStack[localStack.length - 1].function || "")) {
            localStack.pop();
        }
    }
    return localStack.slice(0, STACKTRACE_FRAME_LIMIT).map(function(frame) {
        return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, frame), {
            filename: frame.filename || localStack[localStack.length - 1].filename,
            function: frame.function || "?"
        });
    });
}
var defaultFunctionName = "<anonymous>";
/**
 * Safely extract function name from itself
 */ function getFunctionName(fn) {
    try {
        if (!fn || typeof fn !== "function") {
            return defaultFunctionName;
        }
        return fn.name || defaultFunctionName;
    } catch (e) {
        // Just accessing custom props in some Selenium environments
        // can cause a "Permission denied" exception (see raven-js#495).
        return defaultFunctionName;
    }
}
/**
 * Node.js stack line parser
 *
 * This is in @sentry/utils so it can be used from the Electron SDK in the browser for when `nodeIntegration == true`.
 * This allows it to be used without referencing or importing any node specific code which causes bundlers to complain
 */ function nodeStackLineParser(getModule) {
    return [
        90,
        node(getModule)
    ];
}
 //# sourceMappingURL=stacktrace.js.map


/***/ }),

/***/ 68813:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$G": function() { return /* binding */ truncate; },
/* harmony export */   "JM": function() { return /* binding */ snipLine; },
/* harmony export */   "U0": function() { return /* binding */ stringMatchesSomePattern; },
/* harmony export */   "nK": function() { return /* binding */ safeJoin; }
/* harmony export */ });
/* unused harmony export isMatchingPattern */
/* harmony import */ var _is_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(74020);

/**
 * Truncates given string to the maximum characters count
 *
 * @param str An object that contains serializable values
 * @param max Maximum number of characters in truncated string (0 = unlimited)
 * @returns string Encoded
 */ function truncate(str) {
    var max = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
    if (typeof str !== "string" || max === 0) {
        return str;
    }
    return str.length <= max ? str : "".concat(str.slice(0, max), "...");
}
/**
 * This is basically just `trim_line` from
 * https://github.com/getsentry/sentry/blob/master/src/sentry/lang/javascript/processor.py#L67
 *
 * @param str An object that contains serializable values
 * @param max Maximum number of characters in truncated string
 * @returns string Encoded
 */ function snipLine(line, colno) {
    var newLine = line;
    var lineLength = newLine.length;
    if (lineLength <= 150) {
        return newLine;
    }
    if (colno > lineLength) {
        // eslint-disable-next-line no-param-reassign
        colno = lineLength;
    }
    var start = Math.max(colno - 60, 0);
    if (start < 5) {
        start = 0;
    }
    var end = Math.min(start + 140, lineLength);
    if (end > lineLength - 5) {
        end = lineLength;
    }
    if (end === lineLength) {
        start = Math.max(end - 140, 0);
    }
    newLine = newLine.slice(start, end);
    if (start > 0) {
        newLine = "'{snip} ".concat(newLine);
    }
    if (end < lineLength) {
        newLine += " {snip}";
    }
    return newLine;
}
/**
 * Join values in array
 * @param input array of values to be joined together
 * @param delimiter string to be placed in-between values
 * @returns Joined values
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function safeJoin(input, delimiter) {
    if (!Array.isArray(input)) {
        return "";
    }
    var output = [];
    // eslint-disable-next-line @typescript-eslint/prefer-for-of
    for(var i = 0; i < input.length; i++){
        var value = input[i];
        try {
            // This is a hack to fix a Vue3-specific bug that causes an infinite loop of
            // console warnings. This happens when a Vue template is rendered with
            // an undeclared variable, which we try to stringify, ultimately causing
            // Vue to issue another warning which repeats indefinitely.
            // see: https://github.com/getsentry/sentry-javascript/pull/8981
            if ((0,_is_js__WEBPACK_IMPORTED_MODULE_0__/* .isVueViewModel */ .y1)(value)) {
                output.push("[VueViewModel]");
            } else {
                output.push(String(value));
            }
        } catch (e) {
            output.push("[value cannot be serialized]");
        }
    }
    return output.join(delimiter);
}
/**
 * Checks if the given value matches a regex or string
 *
 * @param value The string to test
 * @param pattern Either a regex or a string against which `value` will be matched
 * @param requireExactStringMatch If true, `value` must match `pattern` exactly. If false, `value` will match
 * `pattern` if it contains `pattern`. Only applies to string-type patterns.
 */ function isMatchingPattern(value, pattern) {
    var requireExactStringMatch = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
    if (!(0,_is_js__WEBPACK_IMPORTED_MODULE_0__/* .isString */ .HD)(value)) {
        return false;
    }
    if ((0,_is_js__WEBPACK_IMPORTED_MODULE_0__/* .isRegExp */ .Kj)(pattern)) {
        return pattern.test(value);
    }
    if ((0,_is_js__WEBPACK_IMPORTED_MODULE_0__/* .isString */ .HD)(pattern)) {
        return requireExactStringMatch ? value === pattern : value.includes(pattern);
    }
    return false;
}
/**
 * Test the given string against an array of strings and regexes. By default, string matching is done on a
 * substring-inclusion basis rather than a strict equality basis
 *
 * @param testString The string to test
 * @param patterns The patterns against which to test the string
 * @param requireExactStringMatch If true, `testString` must match one of the given string patterns exactly in order to
 * count. If false, `testString` will match a string pattern if it contains that pattern.
 * @returns
 */ function stringMatchesSomePattern(testString) {
    var patterns = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [], requireExactStringMatch = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
    return patterns.some(function(pattern) {
        return isMatchingPattern(testString, pattern, requireExactStringMatch);
    });
}
 //# sourceMappingURL=string.js.map


/***/ }),

/***/ 21200:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$2": function() { return /* binding */ rejectedSyncPromise; },
/* harmony export */   "WD": function() { return /* binding */ resolvedSyncPromise; },
/* harmony export */   "cW": function() { return /* binding */ SyncPromise; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(51438);
/* harmony import */ var _swc_helpers_src_create_class_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52951);
/* harmony import */ var _is_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(74020);



/* eslint-disable @typescript-eslint/explicit-function-return-type */ /** SyncPromise internal states */ var States;
(function(States) {
    /** Pending */ var PENDING = 0;
    States[States["PENDING"] = PENDING] = "PENDING";
    /** Resolved / OK */ var RESOLVED = 1;
    States[States["RESOLVED"] = RESOLVED] = "RESOLVED";
    /** Rejected / Error */ var REJECTED = 2;
    States[States["REJECTED"] = REJECTED] = "REJECTED";
})(States || (States = {}));
// Overloads so we can call resolvedSyncPromise without arguments and generic argument
/**
 * Creates a resolved sync promise.
 *
 * @param value the value to resolve the promise with
 * @returns the resolved sync promise
 */ function resolvedSyncPromise(value) {
    return new SyncPromise(function(resolve) {
        resolve(value);
    });
}
/**
 * Creates a rejected sync promise.
 *
 * @param value the value to reject the promise with
 * @returns the rejected sync promise
 */ function rejectedSyncPromise(reason) {
    return new SyncPromise(function(_, reject) {
        reject(reason);
    });
}
/**
 * Thenable class that behaves like a Promise and follows it's interface
 * but is not async internally
 */ var SyncPromise = /*#__PURE__*/ function() {
    "use strict";
    function SyncPromise(executor) {
        (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(this, SyncPromise);
        SyncPromise.prototype.__init.call(this);
        SyncPromise.prototype.__init2.call(this);
        SyncPromise.prototype.__init3.call(this);
        SyncPromise.prototype.__init4.call(this);
        this._state = States.PENDING;
        this._handlers = [];
        try {
            executor(this._resolve, this._reject);
        } catch (e) {
            this._reject(e);
        }
    }
    (0,_swc_helpers_src_create_class_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(SyncPromise, [
        {
            /** JSDoc */ key: "then",
            value: function then(onfulfilled, onrejected) {
                var _this = this;
                return new SyncPromise(function(resolve, reject) {
                    _this._handlers.push([
                        false,
                        function(result) {
                            if (!onfulfilled) {
                                // TODO: ¯\_(ツ)_/¯
                                // TODO: FIXME
                                resolve(result);
                            } else {
                                try {
                                    resolve(onfulfilled(result));
                                } catch (e) {
                                    reject(e);
                                }
                            }
                        },
                        function(reason) {
                            if (!onrejected) {
                                reject(reason);
                            } else {
                                try {
                                    resolve(onrejected(reason));
                                } catch (e) {
                                    reject(e);
                                }
                            }
                        }, 
                    ]);
                    _this._executeHandlers();
                });
            }
        },
        {
            /** JSDoc */ key: "catch",
            value: function _catch(onrejected) {
                return this.then(function(val) {
                    return val;
                }, onrejected);
            }
        },
        {
            /** JSDoc */ key: "finally",
            value: function _finally(onfinally) {
                var _this = this;
                return new SyncPromise(function(resolve, reject) {
                    var val;
                    var isRejected;
                    return _this.then(function(value) {
                        isRejected = false;
                        val = value;
                        if (onfinally) {
                            onfinally();
                        }
                    }, function(reason) {
                        isRejected = true;
                        val = reason;
                        if (onfinally) {
                            onfinally();
                        }
                    }).then(function() {
                        if (isRejected) {
                            reject(val);
                            return;
                        }
                        resolve(val);
                    });
                });
            }
        },
        {
            /** JSDoc */ key: "__init",
            value: function __init() {
                var _this = this;
                this._resolve = function(value) {
                    _this._setResult(States.RESOLVED, value);
                };
            }
        },
        {
            /** JSDoc */ key: "__init2",
            value: function __init2() {
                var _this = this;
                this._reject = function(reason) {
                    _this._setResult(States.REJECTED, reason);
                };
            }
        },
        {
            /** JSDoc */ key: "__init3",
            value: function __init3() {
                var _this = this;
                this._setResult = function(state, value) {
                    if (_this._state !== States.PENDING) {
                        return;
                    }
                    if ((0,_is_js__WEBPACK_IMPORTED_MODULE_2__/* .isThenable */ .J8)(value)) {
                        void value.then(_this._resolve, _this._reject);
                        return;
                    }
                    _this._state = state;
                    _this._value = value;
                    _this._executeHandlers();
                };
            }
        },
        {
            /** JSDoc */ key: "__init4",
            value: function __init4() {
                var _this = this;
                this._executeHandlers = function() {
                    if (_this._state === States.PENDING) {
                        return;
                    }
                    var cachedHandlers = _this._handlers.slice();
                    _this._handlers = [];
                    cachedHandlers.forEach(function(handler) {
                        if (handler[0]) {
                            return;
                        }
                        if (_this._state === States.RESOLVED) {
                            // eslint-disable-next-line @typescript-eslint/no-floating-promises
                            handler[1](_this._value);
                        }
                        if (_this._state === States.REJECTED) {
                            handler[2](_this._value);
                        }
                        handler[0] = true;
                    });
                };
            }
        }
    ]);
    return SyncPromise;
}();
 //# sourceMappingURL=syncpromise.js.map


/***/ }),

/***/ 96233:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z1": function() { return /* binding */ browserPerformanceTimeOrigin; },
/* harmony export */   "ph": function() { return /* binding */ timestampInSeconds; },
/* harmony export */   "yW": function() { return /* binding */ dateTimestampInSeconds; }
/* harmony export */ });
/* unused harmony exports _browserPerformanceTimeOriginMode, timestampWithMs */
/* harmony import */ var _worldwide_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(74672);

var ONE_SECOND_IN_MS = 1000;
/**
 * A partial definition of the [Performance Web API]{@link https://developer.mozilla.org/en-US/docs/Web/API/Performance}
 * for accessing a high-resolution monotonic clock.
 */ /**
 * Returns a timestamp in seconds since the UNIX epoch using the Date API.
 *
 * TODO(v8): Return type should be rounded.
 */ function dateTimestampInSeconds() {
    return Date.now() / ONE_SECOND_IN_MS;
}
/**
 * Returns a wrapper around the native Performance API browser implementation, or undefined for browsers that do not
 * support the API.
 *
 * Wrapping the native API works around differences in behavior from different browsers.
 */ function createUnixTimestampInSecondsFunc() {
    var performance = _worldwide_js__WEBPACK_IMPORTED_MODULE_0__/* .GLOBAL_OBJ.performance */ .n2.performance;
    if (!performance || !performance.now) {
        return dateTimestampInSeconds;
    }
    // Some browser and environments don't have a timeOrigin, so we fallback to
    // using Date.now() to compute the starting time.
    var approxStartingTimeOrigin = Date.now() - performance.now();
    var timeOrigin = performance.timeOrigin == undefined ? approxStartingTimeOrigin : performance.timeOrigin;
    // performance.now() is a monotonic clock, which means it starts at 0 when the process begins. To get the current
    // wall clock time (actual UNIX timestamp), we need to add the starting time origin and the current time elapsed.
    //
    // TODO: This does not account for the case where the monotonic clock that powers performance.now() drifts from the
    // wall clock time, which causes the returned timestamp to be inaccurate. We should investigate how to detect and
    // correct for this.
    // See: https://github.com/getsentry/sentry-javascript/issues/2590
    // See: https://github.com/mdn/content/issues/4713
    // See: https://dev.to/noamr/when-a-millisecond-is-not-a-millisecond-3h6
    return function() {
        return (timeOrigin + performance.now()) / ONE_SECOND_IN_MS;
    };
}
/**
 * Returns a timestamp in seconds since the UNIX epoch using either the Performance or Date APIs, depending on the
 * availability of the Performance API.
 *
 * BUG: Note that because of how browsers implement the Performance API, the clock might stop when the computer is
 * asleep. This creates a skew between `dateTimestampInSeconds` and `timestampInSeconds`. The
 * skew can grow to arbitrary amounts like days, weeks or months.
 * See https://github.com/getsentry/sentry-javascript/issues/2590.
 */ var timestampInSeconds = createUnixTimestampInSecondsFunc();
/**
 * Re-exported with an old name for backwards-compatibility.
 * TODO (v8): Remove this
 *
 * @deprecated Use `timestampInSeconds` instead.
 */ var timestampWithMs = (/* unused pure expression or super */ null && (timestampInSeconds));
/**
 * Internal helper to store what is the source of browserPerformanceTimeOrigin below. For debugging only.
 */ var _browserPerformanceTimeOriginMode;
/**
 * The number of milliseconds since the UNIX epoch. This value is only usable in a browser, and only when the
 * performance API is available.
 */ var browserPerformanceTimeOrigin = function() {
    // Unfortunately browsers may report an inaccurate time origin data, through either performance.timeOrigin or
    // performance.timing.navigationStart, which results in poor results in performance data. We only treat time origin
    // data as reliable if they are within a reasonable threshold of the current time.
    var performance = _worldwide_js__WEBPACK_IMPORTED_MODULE_0__/* .GLOBAL_OBJ.performance */ .n2.performance;
    if (!performance || !performance.now) {
        _browserPerformanceTimeOriginMode = "none";
        return undefined;
    }
    var threshold = 3600 * 1000;
    var performanceNow = performance.now();
    var dateNow = Date.now();
    // if timeOrigin isn't available set delta to threshold so it isn't used
    var timeOriginDelta = performance.timeOrigin ? Math.abs(performance.timeOrigin + performanceNow - dateNow) : threshold;
    var timeOriginIsReliable = timeOriginDelta < threshold;
    // While performance.timing.navigationStart is deprecated in favor of performance.timeOrigin, performance.timeOrigin
    // is not as widely supported. Namely, performance.timeOrigin is undefined in Safari as of writing.
    // Also as of writing, performance.timing is not available in Web Workers in mainstream browsers, so it is not always
    // a valid fallback. In the absence of an initial time provided by the browser, fallback to the current time from the
    // Date API.
    // eslint-disable-next-line deprecation/deprecation
    var navigationStart = performance.timing && performance.timing.navigationStart;
    var hasNavigationStart = typeof navigationStart === "number";
    // if navigationStart isn't available set delta to threshold so it isn't used
    var navigationStartDelta = hasNavigationStart ? Math.abs(navigationStart + performanceNow - dateNow) : threshold;
    var navigationStartIsReliable = navigationStartDelta < threshold;
    if (timeOriginIsReliable || navigationStartIsReliable) {
        // Use the more reliable time origin
        if (timeOriginDelta <= navigationStartDelta) {
            _browserPerformanceTimeOriginMode = "timeOrigin";
            return performance.timeOrigin;
        } else {
            _browserPerformanceTimeOriginMode = "navigationStart";
            return navigationStart;
        }
    }
    // Either both timeOrigin and navigationStart are skewed or neither is available, fallback to Date.
    _browserPerformanceTimeOriginMode = "dateNow";
    return dateNow;
}();
 //# sourceMappingURL=time.js.map


/***/ }),

/***/ 84907:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$p": function() { return /* binding */ generateSentryTraceHeader; },
/* harmony export */   "KA": function() { return /* binding */ tracingContextFromHeaders; },
/* harmony export */   "pT": function() { return /* binding */ propagationContextFromHeaders; },
/* harmony export */   "qG": function() { return /* binding */ extractTraceparentData; }
/* harmony export */ });
/* unused harmony export TRACEPARENT_REGEXP */
/* harmony import */ var _baggage_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(50257);
/* harmony import */ var _misc_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(11591);


// eslint-disable-next-line @sentry-internal/sdk/no-regexp-constructor -- RegExp is used for readability here
var TRACEPARENT_REGEXP = new RegExp("^[ \\t]*" + // whitespace
"([0-9a-f]{32})?" + // trace_id
"-?([0-9a-f]{16})?" + // span_id
"-?([01])?" + // sampled
"[ \\t]*$");
/**
 * Extract transaction context data from a `sentry-trace` header.
 *
 * @param traceparent Traceparent string
 *
 * @returns Object containing data from the header, or undefined if traceparent string is malformed
 */ function extractTraceparentData(traceparent) {
    if (!traceparent) {
        return undefined;
    }
    var matches = traceparent.match(TRACEPARENT_REGEXP);
    if (!matches) {
        return undefined;
    }
    var parentSampled;
    if (matches[3] === "1") {
        parentSampled = true;
    } else if (matches[3] === "0") {
        parentSampled = false;
    }
    return {
        traceId: matches[1],
        parentSampled: parentSampled,
        parentSpanId: matches[2]
    };
}
/**
 * Create tracing context from incoming headers.
 *
 * @deprecated Use `propagationContextFromHeaders` instead.
 */ // TODO(v8): Remove this function
function tracingContextFromHeaders(sentryTrace, baggage) {
    var traceparentData = extractTraceparentData(sentryTrace);
    var dynamicSamplingContext = (0,_baggage_js__WEBPACK_IMPORTED_MODULE_0__/* .baggageHeaderToDynamicSamplingContext */ .EN)(baggage);
    var ref = traceparentData || {}, traceId = ref.traceId, parentSpanId = ref.parentSpanId, parentSampled = ref.parentSampled;
    if (!traceparentData) {
        return {
            traceparentData: traceparentData,
            dynamicSamplingContext: undefined,
            propagationContext: {
                traceId: traceId || (0,_misc_js__WEBPACK_IMPORTED_MODULE_1__/* .uuid4 */ .DM)(),
                spanId: (0,_misc_js__WEBPACK_IMPORTED_MODULE_1__/* .uuid4 */ .DM)().substring(16)
            }
        };
    } else {
        return {
            traceparentData: traceparentData,
            dynamicSamplingContext: dynamicSamplingContext || {},
            propagationContext: {
                traceId: traceId || (0,_misc_js__WEBPACK_IMPORTED_MODULE_1__/* .uuid4 */ .DM)(),
                parentSpanId: parentSpanId || (0,_misc_js__WEBPACK_IMPORTED_MODULE_1__/* .uuid4 */ .DM)().substring(16),
                spanId: (0,_misc_js__WEBPACK_IMPORTED_MODULE_1__/* .uuid4 */ .DM)().substring(16),
                sampled: parentSampled,
                dsc: dynamicSamplingContext || {}
            }
        };
    }
}
/**
 * Create a propagation context from incoming headers.
 */ function propagationContextFromHeaders(sentryTrace, baggage) {
    var traceparentData = extractTraceparentData(sentryTrace);
    var dynamicSamplingContext = (0,_baggage_js__WEBPACK_IMPORTED_MODULE_0__/* .baggageHeaderToDynamicSamplingContext */ .EN)(baggage);
    var ref = traceparentData || {}, traceId = ref.traceId, parentSpanId = ref.parentSpanId, parentSampled = ref.parentSampled;
    if (!traceparentData) {
        return {
            traceId: traceId || (0,_misc_js__WEBPACK_IMPORTED_MODULE_1__/* .uuid4 */ .DM)(),
            spanId: (0,_misc_js__WEBPACK_IMPORTED_MODULE_1__/* .uuid4 */ .DM)().substring(16)
        };
    } else {
        return {
            traceId: traceId || (0,_misc_js__WEBPACK_IMPORTED_MODULE_1__/* .uuid4 */ .DM)(),
            parentSpanId: parentSpanId || (0,_misc_js__WEBPACK_IMPORTED_MODULE_1__/* .uuid4 */ .DM)().substring(16),
            spanId: (0,_misc_js__WEBPACK_IMPORTED_MODULE_1__/* .uuid4 */ .DM)().substring(16),
            sampled: parentSampled,
            dsc: dynamicSamplingContext || {}
        };
    }
}
/**
 * Create sentry-trace header from span context values.
 */ function generateSentryTraceHeader() {
    var traceId = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : (0,_misc_js__WEBPACK_IMPORTED_MODULE_1__/* .uuid4 */ .DM)(), spanId = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : (0,_misc_js__WEBPACK_IMPORTED_MODULE_1__/* .uuid4 */ .DM)().substring(16), sampled = arguments.length > 2 ? arguments[2] : void 0;
    var sampledString = "";
    if (sampled !== undefined) {
        sampledString = sampled ? "-1" : "-0";
    }
    return "".concat(traceId, "-").concat(spanId).concat(sampledString);
}
 //# sourceMappingURL=tracing.js.map


/***/ }),

/***/ 74672:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Rf": function() { return /* binding */ getGlobalObject; },
/* harmony export */   "YO": function() { return /* binding */ getGlobalSingleton; },
/* harmony export */   "n2": function() { return /* binding */ GLOBAL_OBJ; }
/* harmony export */ });
/** Internal global with common properties and Sentry extensions  */ // The code below for 'isGlobalObj' and 'GLOBAL_OBJ' was copied from core-js before modification
// https://github.com/zloirock/core-js/blob/1b944df55282cdc99c90db5f49eb0b6eda2cc0a3/packages/core-js/internals/global.js
// core-js has the following licence:
//
// Copyright (c) 2014-2022 Denis Pushkarev
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in
// all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
// THE SOFTWARE.
/** Returns 'obj' if it's the global object, otherwise returns undefined */ function isGlobalObj(obj) {
    return obj && obj.Math == Math ? obj : undefined;
}
/** Get's the global object for the current JavaScript runtime */ var GLOBAL_OBJ = typeof globalThis == "object" && isGlobalObj(globalThis) || // eslint-disable-next-line no-restricted-globals
 true && isGlobalObj(window) || typeof self == "object" && isGlobalObj(self) || typeof __webpack_require__.g == "object" && isGlobalObj(__webpack_require__.g) || function() {
    return this;
}() || {};
/**
 * @deprecated Use GLOBAL_OBJ instead or WINDOW from @sentry/browser. This will be removed in v8
 */ function getGlobalObject() {
    return GLOBAL_OBJ;
}
/**
 * Returns a global singleton contained in the global `__SENTRY__` object.
 *
 * If the singleton doesn't already exist in `__SENTRY__`, it will be created using the given factory
 * function and added to the `__SENTRY__` object.
 *
 * @param name name of the global singleton on __SENTRY__
 * @param creator creator Factory function to create the singleton if it doesn't already exist on `__SENTRY__`
 * @param obj (Optional) The global object on which to look for `__SENTRY__`, if not `GLOBAL_OBJ`'s return value
 * @returns the singleton
 */ function getGlobalSingleton(name, creator, obj) {
    var gbl = obj || GLOBAL_OBJ;
    var __SENTRY__ = gbl.__SENTRY__ = gbl.__SENTRY__ || {};
    var singleton = __SENTRY__[name] || (__SENTRY__[name] = creator());
    return singleton;
}
 //# sourceMappingURL=worldwide.js.map


/***/ }),

/***/ 52951:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _createClass; }
/* harmony export */ });
function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}


/***/ })

}]);